(function() {
  "use strict";

  if (window.__ccfInitCollectionFilters) {
    window.__ccfInitCollectionFilters(document);
    return;
  }

  function initCollectionFilters(root) {
      if (!root || root.nodeType !== 1) return;
      if (root.dataset.ccfInitialized === "true") return;
      root.dataset.ccfInitialized = "true";

      var grid = root.querySelector("[data-ccf-grid]");
      if (!grid) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-ccf-product]"));
      if (!cards.length) return;
      var visibleCardSet = new Set(cards.filter(function(card) {
        return !card.classList.contains("ccf-grid__item--page-hidden");
      }));

      // Paginate metadata supplied by the server-rendered grid.
      var CCF_TOTAL_PAGES = parseInt(grid.getAttribute("data-ccf-total-pages") || "1", 10) || 1;
      var CCF_PAGE_SIZE = parseInt(grid.getAttribute("data-ccf-page-size") || root.getAttribute("data-ccf-default-items") || "48", 10) || 48;
      var CCF_TOTAL_ITEMS = parseInt(grid.getAttribute("data-ccf-total-items") || "0", 10) || 0;
      var CCF_CURRENT_SERVER_PAGE = parseInt(grid.getAttribute("data-ccf-current-page") || "1", 10) || 1;
      var CCF_SECTION_ID = root.getAttribute("data-ccf-section-id") || "";

      // Track loaded product IDs to prevent duplicates when fetching more pages
      var loadedProductIds = {};
      cards.forEach(function(card) {
        var pid = card.getAttribute("data-product-id");
        if (pid) loadedProductIds[pid] = true;
      });

      var CURRENCY_CODE = root.getAttribute("data-ccf-currency-code") || "USD";

      // Common currency minor unit exponents:
      // 0-decimal: JPY, KRW, VND, etc.
      // 3-decimal: BHD, KWD, OMR, etc.
      var ZERO_DECIMAL_CURRENCIES = [
        "BIF","CLP","DJF","GNF","JPY","KMF","KRW","MGA","PYG","RWF","UGX","VND","VUV","XAF","XOF","XPF"
      ];
      var THREE_DECIMAL_CURRENCIES = [
        "BHD","IQD","JOD","KWD","LYD","OMR","TND"
      ];

      var currencyDecimals = 2;
      if (ZERO_DECIMAL_CURRENCIES.indexOf(CURRENCY_CODE) !== -1) currencyDecimals = 0;
      if (THREE_DECIMAL_CURRENCIES.indexOf(CURRENCY_CODE) !== -1) currencyDecimals = 3;

      var MONEY_FACTOR = Math.pow(10, currencyDecimals);

      function minorToMajor(minor) {
        return minor / MONEY_FACTOR;
      }

      function majorToMinor(major) {
        if (major === null || major === undefined) return NaN;
        var n = parseFloat(major);
        if (isNaN(n)) return NaN;
        return Math.round(n * MONEY_FACTOR);
      }

      function formatMajorNumber(major) {
        if (major === null || major === undefined || isNaN(major)) return "";
        if (currencyDecimals === 0) return String(Math.round(major));

        var fixed = Number(major).toFixed(currencyDecimals);
        // Trim trailing zeros for nicer UX (19.00 -> 19, 19.50 -> 19.5)
        fixed = fixed.replace(/(\.\d*?[1-9])0+$/,"$1").replace(/\.0+$/,"");
        return fixed;
      }

      // -------------------------
      // DOM refs
      // -------------------------
      var filterPanel = root.querySelector("[data-ccf-filter-panel]");
      var priceMinInput = root.querySelector("[data-ccf-price-input='min']");
      var priceMaxInput = root.querySelector("[data-ccf-price-input='max']");
      var priceMinRange = root.querySelector("[data-ccf-price-range='min']");
      var priceMaxRange = root.querySelector("[data-ccf-price-range='max']");
      var priceRangeFill = root.querySelector("[data-ccf-range-fill]");
      var priceRangeWrap = root.querySelector("[data-ccf-price-range-wrap]");

      var capacityInput = root.querySelector("[data-ccf-capacity-input]");
      var capacityRange = root.querySelector("[data-ccf-capacity-range]");
      var capacityRangeFill = root.querySelector("[data-ccf-capacity-range-fill]");

      var toggleFiltersButton = root.querySelector("[data-ccf-toggle-filters]");
      var closeFiltersButton = root.querySelector("[data-ccf-close-filters]");
      var clearButton = root.querySelector("[data-ccf-clear]");
      var backdrop = root.querySelector("[data-ccf-backdrop]");
      var productCountText = root.querySelector("[data-ccf-product-count]");
      var paginationEl = root.querySelector("[data-ccf-pagination]");
      var serverPaginationEl = root.querySelector("[data-ccf-server-pagination]");
      var materialContainer = root.querySelector("[data-ccf-options='material']");
      var sortSelect = root.querySelector("[data-ccf-sort]");
      var pageSizeSelect = root.querySelector("[data-ccf-page-size]");
      var noResultsEl = root.querySelector("[data-ccf-no-results]");
      var applyFiltersButton = root.querySelector("[data-ccf-apply-filters]");
      var loadingTextEl = root.querySelector("[data-ccf-loading]");

      // These exist in HTML (not dynamically injected)
      var hideOosCheckbox = root.querySelector("input[data-ccf-filter='hide-oos']");
      var hideOosStatus = root.querySelector("[data-ccf-hide-oos-status]");
      var onSaleCheckbox = root.querySelector("input[data-ccf-filter='on-sale']");
      var customCheckbox = root.querySelector("input[data-ccf-filter='custom-only']");

      // -------------------------
      // Client-side pagination + sort state
      // -------------------------
      var DEFAULT_ITEMS_PER_PAGE = parseInt(root.getAttribute("data-ccf-default-items") || String(CCF_PAGE_SIZE), 10) || CCF_PAGE_SIZE;
      var ITEMS_PER_PAGE = DEFAULT_ITEMS_PER_PAGE;
      var currentPage = Math.max(1, CCF_CURRENT_SERVER_PAGE || 1);

      var sortState = "default";

      // Until all native Shopify pages are merged after shopper interaction,
      // restored filters/pages must not be clamped to the first partial batch.
      var hasLoadedAllProducts = !(CCF_TOTAL_PAGES && CCF_TOTAL_PAGES > 1);
      var clientCatalogActive = false;
      var restoredDesiredPage = null;

      // Product-return helpers. These are storage-only; the URL stays clean.
      var clickedProductIdForReturn = null;
      var clickedScrollYForReturn = null;
      var clickedViewportTopForReturn = null;
      var clickedWithKeyboardForReturn = false;
      var returnPendingAt = 0;
      var returnAnchorProductId = null;
      var returnAnchorViewportTop = null;
      var returnScrollY = null;
      var returnShouldFocus = false;
      var hasRestoredReturnPosition = false;
      var restoredNeedsFullCatalog = false;

      // Track whether user touched these controls (so we don't overwrite their values while loading more products)
      var priceMinTouched = false;
      var priceMaxTouched = false;
      var capacityTouched = false;

      // rAF scheduler to avoid doing heavy work too often (sliders, rapid changes)
      var applyRaf = null;
      var rangeApplyTimer = null;
      var pendingApplyOnPageShow = false;
      var mobilePreviewDirty = false;
      function requestApply() {
        if (!hasLoadedAllProducts) {
          if (!isLoadingAllProducts) loadAllProductsAcrossPages();
          return;
        }
        clientCatalogActive = true;
        if (serverPaginationEl) serverPaginationEl.hidden = true;
        if (applyRaf) return;
        applyRaf = window.requestAnimationFrame(function() {
          applyRaf = null;
          applyFilters();
        });
      }

      function scheduleRangeApply() {
        if (rangeApplyTimer) return;
        rangeApplyTimer = window.setTimeout(function() {
          rangeApplyTimer = null;
          requestApply();
        }, 90);
      }

      function flushRangeApply(force) {
        var hadPendingApply = !!rangeApplyTimer;
        if (hadPendingApply) {
          window.clearTimeout(rangeApplyTimer);
          rangeApplyTimer = null;
        }
        if (hadPendingApply || force) requestApply();
      }

      function deferRangeApplyForNavigation() {
        if (!rangeApplyTimer) return;
        window.clearTimeout(rangeApplyTimer);
        rangeApplyTimer = null;
        pendingApplyOnPageShow = true;
      }

      function updateHideOosControl() {
        var markedYes = !!filters.hideOutOfStock;
        var label = "Hide out of stock items: " + (markedYes ? "Yes" : "No");

        if (hideOosCheckbox) {
          hideOosCheckbox.checked = markedYes;
          hideOosCheckbox.setAttribute("aria-label", label);
        }

        if (hideOosStatus) {
          hideOosStatus.textContent = markedYes ? "Yes" : "No";
        }
      }

      function parseNumberLike(value) {
        if (value === null || value === undefined) return NaN;
        var str = String(value).replace(/,/g, "");
        var match = str.match(/-?\d+(\.\d+)?/);
        return match ? parseFloat(match[0]) : NaN;
      }

      function getDataNumber(el, attr, fallback) {
        var raw = el.getAttribute(attr);
        var num = parseNumberLike(raw);
        if (!isNaN(num)) return num;
        return (fallback !== undefined) ? fallback : 0;
      }

      function getDataInt(el, attr, fallback) {
        var raw = el.getAttribute(attr);
        var n = parseInt(raw, 10);
        if (!isNaN(n)) return n;
        return (fallback !== undefined) ? fallback : 0;
      }

      var cardRecords = [];
      var cardRecordByNode = new WeakMap();
      var cardByProductId = Object.create(null);
      var cardsVersion = 0;
      var orderedCardsCache = [];
      var orderedCardsCacheVersion = -1;
      var orderedCardsCacheSort = "";
      var domOrderVersion = -1;
      var domOrderSort = "";
      var materialOptionsSignature = "";
      var paginationSignature = "";
      var gridPageAnimation = null;
      var gridPageAnimationOriginalMinHeight = "";
      var serverNavigationResetTimer = null;
      var titleCollator = (window.Intl && window.Intl.Collator)
        ? new window.Intl.Collator(undefined, { sensitivity: "base", numeric: true })
        : null;

      function createCardRecord(card) {
        var productId = (card.getAttribute("data-product-id") || "").trim();
        var record = {
          node: card,
          productId: productId,
          title: (card.getAttribute("data-title") || "").toLowerCase(),
          priceMinMinor: getDataInt(card, "data-price-min", 0),
          priceMaxMinor: getDataInt(card, "data-price-max", 0),
          capacity: getDataNumber(card, "data-capacity", NaN),
          material: (card.getAttribute("data-material") || "").trim(),
          custom: card.getAttribute("data-custom") || "none",
          available: (card.getAttribute("data-available") || "1") === "1",
          onSale: (card.getAttribute("data-on-sale") || "0") === "1",
          index: getDataInt(card, "data-index", 0)
        };
        if (record.priceMaxMinor < record.priceMinMinor) record.priceMaxMinor = record.priceMinMinor;
        return record;
      }

      function indexCards(cardNodes, reset) {
        if (reset) {
          cardRecords = [];
          cardRecordByNode = new WeakMap();
          cardByProductId = Object.create(null);
        }

        (cardNodes || []).forEach(function(card) {
          var record = createCardRecord(card);
          cardRecords.push(record);
          cardRecordByNode.set(card, record);
          if (record.productId) cardByProductId[record.productId] = card;
        });

        cardsVersion += 1;
        orderedCardsCacheVersion = -1;
        domOrderVersion = -1;
        paginationSignature = "";
      }

      function getCardRecord(card) {
        return cardRecordByNode.get(card) || createCardRecord(card);
      }

      function uniqueSortedNumbers(values) {
        var seen = Object.create(null);
        var out = [];
        (values || []).forEach(function(value) {
          if (!isFinite(value) || value <= 0) return;
          var key = String(value);
          if (seen[key]) return;
          seen[key] = true;
          out.push(value);
        });
        out.sort(function(a, b) { return a - b; });
        return out;
      }

      indexCards(cards, true);

      // ---- Price range setup (minor units; currency-safe) ----
      var allMinPricesMinor = cardRecords.map(function(record) {
        return record.priceMinMinor;
      }).filter(function(v) { return !isNaN(v) && v >= 0; });

      var allMaxPricesMinor = cardRecords.map(function(record) {
        return record.priceMaxMinor;
      }).filter(function(v) { return !isNaN(v) && v >= 0; });

      if (!allMinPricesMinor.length) allMinPricesMinor = [0];
      if (!allMaxPricesMinor.length) allMaxPricesMinor = [0];

      var minPriceMinor = Math.min.apply(Math, allMinPricesMinor);
      var maxPriceMinor = Math.max.apply(Math, allMaxPricesMinor);

      // ---- Capacity range setup ----
      var allCapacities = cardRecords.map(function(record) {
        return record.capacity;
      }).filter(function(v) { return !isNaN(v) && v > 0; });
      var capacityValues = uniqueSortedNumbers(allCapacities);

      var hasCapacityFacet = capacityValues.length > 0;
      var minCapacity = hasCapacityFacet ? capacityValues[0] : 0;
      var maxCapacity = hasCapacityFacet ? capacityValues[capacityValues.length - 1] : 0;

      var filters = {
        priceMinMinor: minPriceMinor,
        priceMaxMinor: maxPriceMinor,
        capacityMin: 0,
        materials: [],
        hideOutOfStock: true,
        onSaleOnly: false,
        customOnly: false
      };

      // -------------------------------------------------------
      // Cookie-free, robust state persistence (URL + Storage)
      // -------------------------------------------------------
      var SL_PARAMS = {
        page: "sl_page",
        show: "sl_show",
        sort: "sl_sort",
        pmin: "sl_pmin",
        pmax: "sl_pmax",
        cap: "sl_cap",
        availability: "sl_availability",
        sale: "sl_sale",
        custom: "sl_custom",
        mat: "sl_mat"
      };

      var SL_STORAGE_KEY = "CCF_STATE::" + window.location.pathname;
      var SL_STORAGE_TTL_MS = 30 * 60 * 1000; // 30 minutes

      var slUrlSyncTimer = null;
      var slStorageSyncTimer = null;

      function slSafeParseInt(value, fallback) {
        var n = parseInt(value, 10);
        if (isNaN(n) || !isFinite(n)) return (fallback !== undefined) ? fallback : 0;
        return n;
      }

      function slSafeParseFloat(value, fallback) {
        var n = parseFloat(value);
        if (isNaN(n) || !isFinite(n)) return (fallback !== undefined) ? fallback : 0;
        return n;
      }

      function slSafeParseBool(value) {
        if (value === true || value === false) return value;
        if (value === 1 || value === "1") return true;
        if (value === 0 || value === "0") return false;
        if (typeof value === "string") {
          var v = value.toLowerCase();
          if (v === "true" || v === "yes" || v === "on") return true;
          if (v === "false" || v === "no" || v === "off") return false;
        }
        return false;
      }

      function slGetUrl() {
        try { return new URL(window.location.href); } catch (e) { return null; }
      }

      function slHasAnyUrlState(url) {
        if (!url) return false;
        var sp = url.searchParams;
        return (
          sp.has(SL_PARAMS.page) ||
          sp.has(SL_PARAMS.show) ||
          sp.has(SL_PARAMS.sort) ||
          sp.has(SL_PARAMS.pmin) ||
          sp.has(SL_PARAMS.pmax) ||
          sp.has(SL_PARAMS.cap) ||
          sp.has(SL_PARAMS.availability) ||
          sp.has(SL_PARAMS.sale) ||
          sp.has(SL_PARAMS.custom) ||
          sp.has(SL_PARAMS.mat)
        );
      }

      function slNormalizeAvailability(value) {
        if (value === true || value === 1 || value === "1") return true;
        if (value === false || value === 0 || value === "0") return false;

        var v = (value || "").toString().trim().toLowerCase();
        if (v === "all" || v === "show_all" || v === "show-all" || v === "false" || v === "off") return false;
        return true;
      }

      function slUniqueStrings(arr) {
        var seen = {};
        var out = [];
        (arr || []).forEach(function(v) {
          var s = (v || "").trim();
          if (!s) return;
          if (seen[s]) return;
          seen[s] = true;
          out.push(s);
        });
        return out;
      }

      function slReadUrlState() {
        var url = slGetUrl();
        if (!slHasAnyUrlState(url)) return null;

        var sp = url.searchParams;
        var state = {};

        if (sp.has(SL_PARAMS.page)) state.page = slSafeParseInt(sp.get(SL_PARAMS.page), 0);
        if (sp.has(SL_PARAMS.show)) state.show = slSafeParseInt(sp.get(SL_PARAMS.show), 0);
        if (sp.has(SL_PARAMS.sort)) state.sort = (sp.get(SL_PARAMS.sort) || "").trim();

        if (sp.has(SL_PARAMS.pmin)) state.pmin = slSafeParseInt(sp.get(SL_PARAMS.pmin), NaN);
        if (sp.has(SL_PARAMS.pmax)) state.pmax = slSafeParseInt(sp.get(SL_PARAMS.pmax), NaN);

        if (sp.has(SL_PARAMS.cap)) state.cap = slSafeParseFloat(sp.get(SL_PARAMS.cap), NaN);

        if (sp.has(SL_PARAMS.availability)) state.availability = (sp.get(SL_PARAMS.availability) || "").trim();

        if (sp.has(SL_PARAMS.sale)) state.sale = slSafeParseBool(sp.get(SL_PARAMS.sale));
        if (sp.has(SL_PARAMS.custom)) state.custom = slSafeParseBool(sp.get(SL_PARAMS.custom));

        var mats = [];
        try { mats = sp.getAll(SL_PARAMS.mat) || []; } catch (e) { mats = []; }
        state.mats = slUniqueStrings(mats);

        return state;
      }

      function slReadStorageState() {
        var raw = null;

        try { raw = window.sessionStorage.getItem(SL_STORAGE_KEY); } catch (e) {}
        if (!raw) {
          try { raw = window.localStorage.getItem(SL_STORAGE_KEY); } catch (e) {}
        }
        if (!raw) return null;

        var payload = null;
        try { payload = JSON.parse(raw); } catch (e) { payload = null; }
        if (!payload || typeof payload !== "object") return null;

        if (payload.path && payload.path !== window.location.pathname) return null;

        var ts = slSafeParseInt(payload.ts, 0);
        if (ts && (Date.now() - ts) > SL_STORAGE_TTL_MS) return null;

        return payload.state || null;
      }

      function slGetPersistedPage() {
        var page = currentPage;

        // During the initial multi-page merge, keep the page the shopper returned to
        // even if the current native server page cannot render that client page yet.
        if (!hasLoadedAllProducts && restoredDesiredPage) {
          var restoredPage = slSafeParseInt(restoredDesiredPage, 0);
          if (restoredPage > 0) page = restoredPage;
        }

        page = slSafeParseInt(page, 1);
        return page > 0 ? page : 1;
      }

      function slClearRestoredPageIntent() {
        restoredDesiredPage = null;
      }

      function slShouldUseReturnAnchor(state) {
        if (!state) return false;

        var pendingAt = slSafeParseInt(state.returnPendingAt, 0);
        if (!pendingAt || (Date.now() - pendingAt) > (10 * 60 * 1000)) return false;

        try {
          var entries = window.performance && window.performance.getEntriesByType
            ? window.performance.getEntriesByType("navigation")
            : [];
          if (entries && entries[0] && entries[0].type === "back_forward") return true;
        } catch (e) {}

        if (!document.referrer) return false;

        try {
          var ref = new URL(document.referrer);
          return ref.origin === window.location.origin && ref.pathname.indexOf("/products/") !== -1;
        } catch (e) {
          return false;
        }
      }

      function slApplyReturnAnchorState(state) {
        if (!state || !slShouldUseReturnAnchor(state)) return;

        var pid = (state.anchorProductId || "").toString().trim();
        if (pid) returnAnchorProductId = pid;
        returnAnchorViewportTop = slSafeParseFloat(state.anchorViewportTop, NaN);
        if (!isFinite(returnAnchorViewportTop)) returnAnchorViewportTop = null;
        returnScrollY = Math.max(0, slSafeParseInt(state.scrollY, 0));
        returnShouldFocus = !!state.returnKeyboard;
      }

      function slWriteStorageState() {
        var state = {
          page: slGetPersistedPage(),
          show: ITEMS_PER_PAGE,
          sort: sortState
        };

        var hasPriceMinFilter = (filters.priceMinMinor > minPriceMinor) || (!hasLoadedAllProducts && priceMinTouched);
        var hasPriceMaxFilter = (filters.priceMaxMinor < maxPriceMinor) || (!hasLoadedAllProducts && priceMaxTouched);
        if (hasPriceMinFilter) state.pmin = filters.priceMinMinor;
        if (hasPriceMaxFilter) state.pmax = filters.priceMaxMinor;

        var hasCapFilter = filters.capacityMin > 0;
        if (hasCapFilter) {
          state.cap = filters.capacityMin;
        }

        if (!filters.hideOutOfStock) state.availability = "all";
        if (filters.onSaleOnly) state.sale = 1;
        if (filters.customOnly) state.custom = 1;

        if (filters.materials && filters.materials.length) {
          state.mats = filters.materials.slice(0);
        }

        if (clickedProductIdForReturn) {
          state.anchorProductId = clickedProductIdForReturn;
        }

        if (clickedScrollYForReturn !== null && clickedScrollYForReturn !== undefined) {
          state.scrollY = Math.max(0, slSafeParseInt(clickedScrollYForReturn, 0));
        }

        if (clickedViewportTopForReturn !== null && clickedViewportTopForReturn !== undefined) {
          state.anchorViewportTop = slSafeParseFloat(clickedViewportTopForReturn, 0);
        }

        if (returnPendingAt) {
          state.returnPendingAt = returnPendingAt;
          if (clickedWithKeyboardForReturn) state.returnKeyboard = true;
        }

        var payload = {
          v: 2,
          path: window.location.pathname,
          ts: Date.now(),
          state: state
        };

        var raw = "";
        try { raw = JSON.stringify(payload); } catch (e) { return; }

        var wroteSession = false;
        try {
          window.sessionStorage.setItem(SL_STORAGE_KEY, raw);
          wroteSession = true;
        } catch (e) {}
        if (!wroteSession) {
          try { window.localStorage.setItem(SL_STORAGE_KEY, raw); } catch (e) {}
        }
      }

      function slAllowedPerPageValues() {
        if (pageSizeSelect && pageSizeSelect.options && pageSizeSelect.options.length) {
          var vals = Array.prototype.map.call(pageSizeSelect.options, function(o) {
            return slSafeParseInt(o.value, 0);
          }).filter(function(v) { return v > 0; });
          return vals.length ? vals : [DEFAULT_ITEMS_PER_PAGE];
        }
        // Fallback to Liquid-derived options
        return [
          DEFAULT_ITEMS_PER_PAGE,
          DEFAULT_ITEMS_PER_PAGE * 2,
          DEFAULT_ITEMS_PER_PAGE * 3,
          DEFAULT_ITEMS_PER_PAGE * 4
        ];
      }

      function slNormalizePerPage(value) {
        var v = slSafeParseInt(value, 0);
        if (v < 1) return DEFAULT_ITEMS_PER_PAGE;

        var allowed = slAllowedPerPageValues();
        if (allowed.indexOf(v) !== -1) return v;

        // Nearest allowed value (avoids breaking if settings changed)
        var best = allowed[0];
        var bestDiff = Math.abs(v - best);
        for (var i = 1; i < allowed.length; i++) {
          var diff = Math.abs(v - allowed[i]);
          if (diff < bestDiff) {
            best = allowed[i];
            bestDiff = diff;
          }
        }
        return best;
      }

      function slAllowedSortValues() {
        if (sortSelect && sortSelect.options && sortSelect.options.length) {
          return Array.prototype.map.call(sortSelect.options, function(o) { return o.value; });
        }
        return ["default", "title-asc", "title-desc", "price-asc", "price-desc"];
      }

      function slNormalizeSort(value) {
        var v = (value || "").trim();
        var allowed = slAllowedSortValues();
        if (allowed.indexOf(v) !== -1) return v;
        return "default";
      }

      function slSyncUrlStateImmediate() {
        if (window.Shopify && window.Shopify.designMode) return;
        if (!clientCatalogActive) return;

        var url = slGetUrl();
        if (!url) return;

        var sp = url.searchParams;

        // Always remove our params first, then add back only what matters.
        // Preserve Shopify's native page URL while the page is server-paginated.
        // Once a shopper explicitly loads the full catalog, client pagination owns the URL.
        if (hasLoadedAllProducts) sp.delete("page");
        sp.delete(SL_PARAMS.page);
        sp.delete(SL_PARAMS.show);
        sp.delete(SL_PARAMS.sort);
        sp.delete(SL_PARAMS.pmin);
        sp.delete(SL_PARAMS.pmax);
        sp.delete(SL_PARAMS.cap);
        sp.delete(SL_PARAMS.availability);
        sp.delete(SL_PARAMS.sale);
        sp.delete(SL_PARAMS.custom);
        sp.delete(SL_PARAMS.mat);

        // Only write non-default values to keep URL clean.
        var pageForUrl = slGetPersistedPage();
        if (pageForUrl && pageForUrl > 1) sp.set(SL_PARAMS.page, String(pageForUrl));
        if (ITEMS_PER_PAGE && ITEMS_PER_PAGE !== DEFAULT_ITEMS_PER_PAGE) sp.set(SL_PARAMS.show, String(ITEMS_PER_PAGE));
        if (sortState && sortState !== "default") sp.set(SL_PARAMS.sort, String(sortState));

        var hasPriceMinFilter = (filters.priceMinMinor > minPriceMinor) || (!hasLoadedAllProducts && priceMinTouched);
        var hasPriceMaxFilter = (filters.priceMaxMinor < maxPriceMinor) || (!hasLoadedAllProducts && priceMaxTouched);
        if (hasPriceMinFilter) sp.set(SL_PARAMS.pmin, String(filters.priceMinMinor));
        if (hasPriceMaxFilter) sp.set(SL_PARAMS.pmax, String(filters.priceMaxMinor));

        var hasCapFilter = filters.capacityMin > 0;
        if (hasCapFilter) sp.set(SL_PARAMS.cap, String(filters.capacityMin));

        if (!filters.hideOutOfStock) sp.set(SL_PARAMS.availability, "all");
        if (filters.onSaleOnly) sp.set(SL_PARAMS.sale, "1");
        if (filters.customOnly) sp.set(SL_PARAMS.custom, "1");

        if (filters.materials && filters.materials.length) {
          filters.materials.forEach(function(mat) {
            if (mat) sp.append(SL_PARAMS.mat, mat);
          });
        }

        try {
          window.history.replaceState(window.history.state, "", url.toString());
        } catch (e) {}
      }

      function slScheduleUrlSync(ms) {
        if (window.Shopify && window.Shopify.designMode) return;
        window.clearTimeout(slUrlSyncTimer);
        slUrlSyncTimer = window.setTimeout(function() {
          slUrlSyncTimer = null;
          slSyncUrlStateImmediate();
        }, (typeof ms === "number" ? ms : 200));
      }

      function slFlushUrlSync() {
        if (slUrlSyncTimer) {
          window.clearTimeout(slUrlSyncTimer);
          slUrlSyncTimer = null;
        }
        slSyncUrlStateImmediate();
      }

      function slScheduleStorageSync(ms) {
        window.clearTimeout(slStorageSyncTimer);
        slStorageSyncTimer = window.setTimeout(function() {
          slStorageSyncTimer = null;
          slWriteStorageState();
        }, (typeof ms === "number" ? ms : 160));
      }

      function slFlushStorageSync() {
        if (slStorageSyncTimer) {
          window.clearTimeout(slStorageSyncTimer);
          slStorageSyncTimer = null;
        }
        slWriteStorageState();
      }

      function slPersistState(options) {
        // options: { url: "immediate" | "debounce" | "none", storage: true/false }
        var opts = options || {};
        var urlMode = opts.url || "debounce";
        var doStorage = (opts.storage !== false);

        if (doStorage) {
          if (urlMode === "immediate" || urlMode === "none") slFlushStorageSync();
          else slScheduleStorageSync(160);
        }
        if (urlMode === "immediate") slFlushUrlSync();
        else if (urlMode === "debounce") slScheduleUrlSync(200);
      }

      function slNormalizeRestoredMinorRange(pmin, pmax, hasPMin, hasPMax) {
        var minVal = hasPMin ? slSafeParseInt(pmin, NaN) : minPriceMinor;
        var maxVal = hasPMax ? slSafeParseInt(pmax, NaN) : maxPriceMinor;

        if (isNaN(minVal)) minVal = minPriceMinor;
        if (isNaN(maxVal)) maxVal = hasPMin ? Math.max(maxPriceMinor, minVal) : maxPriceMinor;

        minVal = Math.max(0, minVal);
        maxVal = Math.max(0, maxVal);

        if (minVal > maxVal) {
          if (hasPMin && hasPMax) {
            var tmp = minVal;
            minVal = maxVal;
            maxVal = tmp;
          } else if (hasPMax) {
            minVal = maxVal;
          } else {
            maxVal = minVal;
          }
        }

        return { min: minVal, max: maxVal };
      }

      function slApplyRestoredState(state) {
        if (!state || typeof state !== "object") return;

        // Page size
        if (state.show) {
          ITEMS_PER_PAGE = slNormalizePerPage(state.show);
          if (pageSizeSelect) pageSizeSelect.value = String(ITEMS_PER_PAGE);
        }

        // Sort
        if (state.sort) {
          sortState = slNormalizeSort(state.sort);
          if (sortSelect) sortSelect.value = String(sortState);
        }

        // Filters
        var hasPMin = (state.pmin !== undefined && !isNaN(state.pmin));
        var hasPMax = (state.pmax !== undefined && !isNaN(state.pmax));
        var hasPrice = (state.pmin !== undefined || state.pmax !== undefined);
        if (hasPrice) {
          priceMinTouched = hasPMin;
          priceMaxTouched = hasPMax;

          // Do not clamp restored prices to the current native server page.
          // Full bounds are known only after the remaining Shopify pages are merged.
          var restoredPrice = slNormalizeRestoredMinorRange(state.pmin, state.pmax, hasPMin, hasPMax);
          filters.priceMinMinor = restoredPrice.min;
          filters.priceMaxMinor = restoredPrice.max;
        }

        if (state.cap !== undefined && !isNaN(state.cap)) {
          capacityTouched = true;

          // Same as price: preserve restored capacity until the full collection is loaded.
          filters.capacityMin = Math.max(0, slSafeParseFloat(state.cap, 0));
        }

        if (state.mats && state.mats.length) {
          filters.materials = slUniqueStrings(state.mats);
        }

        if (state.availability !== undefined) filters.hideOutOfStock = slNormalizeAvailability(state.availability);

        if (state.sale !== undefined) filters.onSaleOnly = !!slSafeParseBool(state.sale);
        if (state.custom !== undefined) filters.customOnly = !!slSafeParseBool(state.custom);

        // Page
        if (state.page) {
          restoredDesiredPage = Math.max(1, slSafeParseInt(state.page, 1));
          currentPage = restoredDesiredPage;
        }

        // Sync static checkboxes immediately (material chips are built later)
        updateHideOosControl();
        if (onSaleCheckbox) onSaleCheckbox.checked = !!filters.onSaleOnly;
        if (customCheckbox) customCheckbox.checked = !!filters.customOnly;
      }

      function slStateRequiresClientCatalog(state) {
        if (!state || typeof state !== "object") return false;
        if (slSafeParseInt(state.page, CCF_CURRENT_SERVER_PAGE) !== CCF_CURRENT_SERVER_PAGE) return true;
        if (slSafeParseInt(state.show, DEFAULT_ITEMS_PER_PAGE) !== DEFAULT_ITEMS_PER_PAGE) return true;
        if (state.sort && slNormalizeSort(state.sort) !== "default") return true;
        if (state.pmin !== undefined || state.pmax !== undefined || state.cap !== undefined) return true;
        if (state.mats && state.mats.length) return true;
        if (state.availability !== undefined || state.sale || state.custom) return true;
        return false;
      }

      function slRestoreStateFromUrlOrStorage() {
        var stored = slReadStorageState();
        var urlState = slReadUrlState();

        if (urlState) {
          restoredNeedsFullCatalog = true;
          slApplyRestoredState(urlState);
          slApplyReturnAnchorState(stored);

          // Keep storage in sync with the URL (URL is the shareable source of truth)
          slPersistState({ url: "none", storage: true });
          return true;
        }

        if (stored) {
          // A clean collection URL should not resurrect old filters/pages from a prior browsing session.
          // Use stored state only for product-page returns where the collection link may have lost URL params.
          if (!slShouldUseReturnAnchor(stored)) return false;

          var storedForRestore = {};
          Object.keys(stored).forEach(function(key) {
            storedForRestore[key] = stored[key];
          });

          restoredNeedsFullCatalog = slStateRequiresClientCatalog(storedForRestore);
          slApplyRestoredState(storedForRestore);
          slApplyReturnAnchorState(stored);

          // Write the restored state into the URL so browser-back works even if return links drop params
          slPersistState({ url: "immediate", storage: true });
          return true;
        }

        return false;
      }

      // Persist state when user is about to leave (best-effort)
      var pageHideHandler = function() {
        if (rangeApplyTimer) {
          deferRangeApplyForNavigation();
        }
        slPersistState({ url: "immediate", storage: true });
      };
      window.addEventListener("pagehide", pageHideHandler);

      // Also flush URL sync right before product navigation (covers quick clicks after slider moves)
      function slFlushBeforeNav(event) {
        var target = event && event.target;
        if (!target) return;

        var link = (target.closest && target.closest("a")) ? target.closest("a") : null;
        if (!link || !link.hasAttribute("data-ccf-product-link")) return;

        var cardEl = (link.closest && link.closest("[data-ccf-product]")) ? link.closest("[data-ccf-product]") : null;
        if (!cardEl) return;

        clickedProductIdForReturn = (cardEl.getAttribute("data-product-id") || "").trim();
        clickedScrollYForReturn = getPageScrollY();
        clickedViewportTopForReturn = cardEl.getBoundingClientRect().top;
        clickedWithKeyboardForReturn = event.type === "click" && event.detail === 0;
        returnPendingAt = Date.now();

        slPersistState({ url: "immediate", storage: true });
      }
      grid.addEventListener("click", slFlushBeforeNav, true);
      grid.addEventListener("auxclick", slFlushBeforeNav, true);

      // -------------------------
      // Sticky offset, counts, UI
      // -------------------------
      function updateStickyOffset() {
        var header = document.querySelector(".shopify-section-header, header[role='banner']");
        var extra = 24;
        var value = 80 + extra;
        if (header) {
          var height = header.offsetHeight || (header.getBoundingClientRect && header.getBoundingClientRect().height) || 0;
          value = height + extra;
        }
        root.style.setProperty("--ccf-sticky-top", value + "px");

        // If switching to desktop, ensure drawer is closed / unlocked.
        if (window.matchMedia && window.matchMedia("(min-width: 990px)").matches) {
          if (root.classList.contains("ccf-section--filters-open")) closeFilters(false);
        }
      }

      function getPageScrollY() {
        return window.pageYOffset || window.scrollY || 0;
      }

      function getSectionTopScrollTarget() {
        var stickyOffset = 0;
        try {
          var styles = window.getComputedStyle(root);
          var val = styles.getPropertyValue("--ccf-sticky-top");
          if (val) stickyOffset = parseFloat(val) || 0;
        } catch (e) {}

        var rect = root.getBoundingClientRect();
        var scrollTop = getPageScrollY() + rect.top - stickyOffset - 10;
        if (scrollTop < 0) scrollTop = 0;

        return scrollTop;
      }

      function isBelowCollectionTop(threshold) {
        var offset = (typeof threshold === 'number') ? threshold : 24;
        return getPageScrollY() > (getSectionTopScrollTarget() + offset);
      }

      function flushResultsTopReset() {
        if (!pendingResultsTopReset) return;
        if (root.classList.contains('ccf-section--filters-open')) return;

        pendingResultsTopReset = false;

        if (isBelowCollectionTop(24)) {
          scrollToSectionTop('auto');
        }
      }

      function scrollToSectionTop(behavior) {
        var scrollTop = getSectionTopScrollTarget();
        var scrollBehavior = behavior || "smooth";

        try {
          window.scrollTo({ top: scrollTop, behavior: scrollBehavior });
        } catch (e) {
          window.scrollTo(0, scrollTop);
        }
      }

      function findCardByProductId(productId) {
        if (!productId) return null;
        return cardByProductId[String(productId)] || null;
      }

      function restoreReturnPositionWhenReady() {
        if (hasRestoredReturnPosition || !returnAnchorProductId) return;

        var card = findCardByProductId(returnAnchorProductId);
        if (!card || card.classList.contains("ccf-grid__item--page-hidden")) return;

        hasRestoredReturnPosition = true;
        var productIdToClear = returnAnchorProductId;
        returnAnchorProductId = null;

        window.requestAnimationFrame(function() {
          window.requestAnimationFrame(function() {
            var rect = card.getBoundingClientRect();
            var targetY = null;

            if (returnAnchorViewportTop !== null && isFinite(returnAnchorViewportTop)) {
              targetY = getPageScrollY() + rect.top - returnAnchorViewportTop;
            } else if (returnScrollY !== null && isFinite(returnScrollY)) {
              targetY = returnScrollY;
            }

            if (targetY !== null) {
              window.scrollTo(0, Math.max(0, targetY));
            } else {
              try {
                card.scrollIntoView({ block: "center", behavior: "auto" });
              } catch (e) {
                window.scrollTo(0, getPageScrollY() + rect.top - 120);
              }
            }

            if (returnShouldFocus) {
              var focusTarget = card.querySelector("[data-ccf-product-link]");
              if (focusTarget && focusTarget.focus) {
                try { focusTarget.focus({ preventScroll: true }); } catch (e) {}
              }
            }

            if (clickedProductIdForReturn === productIdToClear) clickedProductIdForReturn = null;
            clickedScrollYForReturn = null;
            clickedViewportTopForReturn = null;
            clickedWithKeyboardForReturn = false;
            returnPendingAt = 0;
            returnAnchorViewportTop = null;
            returnScrollY = null;
            returnShouldFocus = false;
            slPersistState({ url: "none", storage: true });
          });
        });
      }

      function hasPriceFilterActive() {
        return filters.priceMinMinor > minPriceMinor || filters.priceMaxMinor < maxPriceMinor ||
          (!hasLoadedAllProducts && (priceMinTouched || priceMaxTouched));
      }

      function hasCapacityFilterActive() {
        return filters.capacityMin > 0;
      }

      function hasProductRestrictingFilters() {
        return (
          hasPriceFilterActive() ||
          hasCapacityFilterActive() ||
          filters.materials.length > 0 ||
          filters.hideOutOfStock ||
          filters.onSaleOnly ||
          filters.customOnly
        );
      }

      function getActiveFilterCount() {
        var count = 0;
        if (hasPriceFilterActive()) count += 1;
        if (hasCapacityFilterActive()) count += 1;
        if (filters.materials.length) count += filters.materials.length;
        if (!filters.hideOutOfStock) count += 1;
        if (filters.onSaleOnly) count += 1;
        if (filters.customOnly) count += 1;
        return count;
      }

      // When no product-restricting filters are active, use Shopify’s real collection total immediately,
      // so the “of X products” number does NOT increase while additional pages load.
      function getTotalForText(actualMatchingCount) {
        var knownTotal = CCF_TOTAL_ITEMS;
        if (typeof knownTotal !== "number") knownTotal = parseInt(knownTotal, 10);
        if (isNaN(knownTotal) || knownTotal < 0) knownTotal = 0;

        if (!hasProductRestrictingFilters() && knownTotal > 0) return knownTotal;

        return actualMatchingCount;
      }

      function updateClearAndToggleUI() {
        var active = getActiveFilterCount();

        if (toggleFiltersButton) {
          toggleFiltersButton.textContent = active ? ("Filters (" + active + ")") : "Filters";
        }

        if (clearButton) {
          clearButton.disabled = active === 0;
        }
      }

      function updateApplyButton(totalMatchingForLabel) {
        if (!applyFiltersButton) return;

        var total = parseInt(totalMatchingForLabel, 10);
        if (isNaN(total) || total < 0) total = 0;

        var text = "View results";
        if (total === 0) text = "View 0 results";
        else if (total === 1) text = "View 1 result";
        else text = "View " + total + " results";

        applyFiltersButton.textContent = text;
        applyFiltersButton.disabled = false;
      }

      // ---- Mobile drawer open/close + focus trap + robust scroll lock ----
      var lastActiveElement = null;
      var focusTrapHandler = null;

      var bodyScrollLock = {
        locked: false,
        scrollY: 0,
        style: null
      };

      // Prevent the collection from collapsing to the footer while a range slider is being dragged.
      // We keep the section height stable during the interaction, then return the shopper to the
      // start of the collection once filtering settles.
      var pendingResultsTopReset = false;
      var rangeViewportGuardTimer = null;
      var rangeViewportGuardActive = false;
      var rangePointerActive = false;

      function lockRootMinHeight() {
        if (!root) return;
        var nextHeight = Math.ceil(root.getBoundingClientRect().height || 0);
        if (!nextHeight) return;

        var currentMinHeight = parseFloat(root.style.minHeight || '0') || 0;
        if (nextHeight > currentMinHeight) {
          root.style.minHeight = nextHeight + 'px';
        }
      }

      function unlockRootMinHeight() {
        if (!root) return;
        root.style.minHeight = '';
      }

      function clearRangeViewportGuardTimer() {
        if (!rangeViewportGuardTimer) return;
        window.clearTimeout(rangeViewportGuardTimer);
        rangeViewportGuardTimer = null;
      }

      function queueResultsTopReset() {
        if (root.classList.contains("ccf-section--filters-open")) {
          pendingResultsTopReset = true;
        }
      }

      function beginRangeViewportGuard() {
        if (rangeViewportGuardActive) {
          clearRangeViewportGuardTimer();
          return;
        }
        rangeViewportGuardActive = true;
        if (!root.classList.contains("ccf-section--filters-open")) lockRootMinHeight();
        clearRangeViewportGuardTimer();
      }

      function scheduleRangeViewportRecovery(delay) {
        beginRangeViewportGuard();
        rangeViewportGuardTimer = window.setTimeout(function() {
          rangeViewportGuardTimer = null;
          if (rangePointerActive) return;
          finishRangeViewportGuard();
        }, typeof delay === 'number' ? delay : 140);
      }

      function markRangePointerActive() {
        rangePointerActive = true;
        beginRangeViewportGuard();
      }

      function finishRangeViewportGuard() {
        clearRangeViewportGuardTimer();
        rangeViewportGuardActive = false;
        rangePointerActive = false;

        if (root.classList.contains('ccf-section--filters-open')) {
          return;
        }

        flushResultsTopReset();
        unlockRootMinHeight();
      }

      function lockBodyScroll() {
        if (bodyScrollLock.locked) return;
        if (window.matchMedia && window.matchMedia("(min-width: 990px)").matches) return;

        var body = document.body;
        bodyScrollLock.scrollY = window.scrollY || window.pageYOffset || 0;

        bodyScrollLock.style = {
          position: body.style.position,
          top: body.style.top,
          left: body.style.left,
          right: body.style.right,
          width: body.style.width
        };

        body.classList.add("ccf-scroll-lock");
        body.style.position = "fixed";
        body.style.top = "-" + bodyScrollLock.scrollY + "px";
        body.style.left = "0";
        body.style.right = "0";
        body.style.width = "100%";

        bodyScrollLock.locked = true;
      }

      function unlockBodyScroll() {
        if (!bodyScrollLock.locked) return;

        var body = document.body;
        body.classList.remove("ccf-scroll-lock");

        if (bodyScrollLock.style) {
          body.style.position = bodyScrollLock.style.position;
          body.style.top = bodyScrollLock.style.top;
          body.style.left = bodyScrollLock.style.left;
          body.style.right = bodyScrollLock.style.right;
          body.style.width = bodyScrollLock.style.width;
        } else {
          body.style.position = "";
          body.style.top = "";
          body.style.left = "";
          body.style.right = "";
          body.style.width = "";
        }

        var y = bodyScrollLock.scrollY || 0;
        bodyScrollLock.locked = false;
        bodyScrollLock.scrollY = 0;
        bodyScrollLock.style = null;

        window.scrollTo(0, y);
      }

      function getFocusableElements(container) {
        if (!container) return [];
        var selector = [
          "a[href]",
          "button:not([disabled])",
          "input:not([disabled])",
          "select:not([disabled])",
          "textarea:not([disabled])",
          "[tabindex]:not([tabindex='-1'])"
        ].join(",");
        return Array.prototype.slice.call(container.querySelectorAll(selector))
          .filter(function(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
      }

      function enableFocusTrap() {
        if (!filterPanel) return;
        if (focusTrapHandler) return;

        focusTrapHandler = function(e) {
          if (!root.classList.contains("ccf-section--filters-open")) return;
          if (e.key !== "Tab") return;

          var focusables = getFocusableElements(filterPanel);
          if (!focusables.length) return;

          var first = focusables[0];
          var last = focusables[focusables.length - 1];

          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        };

        document.addEventListener("keydown", focusTrapHandler);
      }

      function disableFocusTrap() {
        if (!focusTrapHandler) return;
        document.removeEventListener("keydown", focusTrapHandler);
        focusTrapHandler = null;
      }

      function openFilters() {
        if (window.matchMedia && window.matchMedia("(min-width: 990px)").matches) return;

        lastActiveElement = document.activeElement;
        root.classList.add("ccf-section--filters-open");
        lockBodyScroll();

        if (toggleFiltersButton) toggleFiltersButton.setAttribute("aria-expanded", "true");
        if (backdrop) backdrop.setAttribute("aria-hidden", "true");

        // Treat as a modal dialog on mobile
        if (filterPanel) {
          filterPanel.setAttribute("role", "dialog");
          filterPanel.setAttribute("aria-modal", "true");
        }

        enableFocusTrap();

        if (closeFiltersButton) {
          closeFiltersButton.focus({ preventScroll: true });
        } else if (filterPanel) {
          var focusables = getFocusableElements(filterPanel);
          if (focusables[0]) focusables[0].focus({ preventScroll: true });
        }
      }

      function closeFilters(restoreFocus) {
        if (restoreFocus === undefined) restoreFocus = true;
        var shouldApplyPreview = mobilePreviewDirty || !!rangeApplyTimer;
        mobilePreviewDirty = false;

        root.classList.remove("ccf-section--filters-open");
        unlockBodyScroll();
        clearRangeViewportGuardTimer();
        rangeViewportGuardActive = false;
        rangePointerActive = false;
        flushResultsTopReset();
        unlockRootMinHeight();

        if (toggleFiltersButton) toggleFiltersButton.setAttribute("aria-expanded", "false");
        if (backdrop) backdrop.setAttribute("aria-hidden", "true");

        if (filterPanel) {
          filterPanel.removeAttribute("role");
          filterPanel.removeAttribute("aria-modal");
        }

        disableFocusTrap();

        if (shouldApplyPreview) flushRangeApply(true);

        if (restoreFocus) {
          if (toggleFiltersButton) {
            toggleFiltersButton.focus({ preventScroll: true });
          } else if (lastActiveElement && lastActiveElement.focus) {
            lastActiveElement.focus({ preventScroll: true });
          }
        }
      }

      // ---- Price helpers (UI in major units, state in minor units) ----
      function updatePriceRangeFill() {
        if (!priceRangeFill || !priceMinRange || !priceMaxRange) return;

        var rangeMinor = (maxPriceMinor - minPriceMinor) || 1;

        var left = ((filters.priceMinMinor - minPriceMinor) / rangeMinor) * 100;
        var right = ((filters.priceMaxMinor - minPriceMinor) / rangeMinor) * 100;

        left = Math.max(0, Math.min(100, left));
        right = Math.max(0, Math.min(100, right));

        priceRangeFill.style.left = left + "%";
        priceRangeFill.style.right = (100 - right) + "%";
      }

      function formatPriceAria(minor) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: CURRENCY_CODE,
            maximumFractionDigits: currencyDecimals
          }).format(minorToMajor(minor));
        } catch (e) {
          return formatMajorNumber(minorToMajor(minor)) + " " + CURRENCY_CODE;
        }
      }

      function updatePriceRangeAria() {
        if (priceMinRange) priceMinRange.setAttribute("aria-valuetext", "Minimum " + formatPriceAria(filters.priceMinMinor));
        if (priceMaxRange) priceMaxRange.setAttribute("aria-valuetext", "Maximum " + formatPriceAria(filters.priceMaxMinor));
      }

      function setActivePriceRange(rangeEl) {
        [priceMinRange, priceMaxRange].forEach(function(candidate) {
          if (!candidate) return;
          var active = candidate === rangeEl;
          candidate.style.zIndex = active ? "3" : "2";
          candidate.toggleAttribute("data-ccf-range-active", active);
        });
      }

      function clampPriceMinor(minValMinor, maxValMinor) {
        if (isNaN(minValMinor)) minValMinor = minPriceMinor;
        if (isNaN(maxValMinor)) maxValMinor = maxPriceMinor;

        minValMinor = Math.max(minPriceMinor, Math.min(maxPriceMinor, minValMinor));
        maxValMinor = Math.max(minPriceMinor, Math.min(maxPriceMinor, maxValMinor));

        if (minValMinor > maxValMinor) {
          var tmp = minValMinor;
          minValMinor = maxValMinor;
          maxValMinor = tmp;
        }

        return { min: minValMinor, max: maxValMinor };
      }

      function updatePriceInputsFromState() {
        if (!priceMinInput || !priceMaxInput || !priceMinRange || !priceMaxRange) return;

        var minMajor = minorToMajor(minPriceMinor);
        var maxMajor = minorToMajor(maxPriceMinor);
        var stepMajor = (currencyDecimals === 0) ? 1 : (1 / MONEY_FACTOR);

        priceMinInput.min = formatMajorNumber(minMajor);
        priceMinInput.max = formatMajorNumber(maxMajor);
        priceMaxInput.min = formatMajorNumber(minMajor);
        priceMaxInput.max = formatMajorNumber(maxMajor);

        priceMinRange.min = formatMajorNumber(minMajor);
        priceMinRange.max = formatMajorNumber(maxMajor);
        priceMaxRange.min = formatMajorNumber(minMajor);
        priceMaxRange.max = formatMajorNumber(maxMajor);

        priceMinInput.step = stepMajor;
        priceMaxInput.step = stepMajor;
        priceMinRange.step = stepMajor;
        priceMaxRange.step = stepMajor;

        priceMinInput.value = formatMajorNumber(minorToMajor(filters.priceMinMinor));
        priceMaxInput.value = formatMajorNumber(minorToMajor(filters.priceMaxMinor));
        priceMinRange.value = formatMajorNumber(minorToMajor(filters.priceMinMinor));
        priceMaxRange.value = formatMajorNumber(minorToMajor(filters.priceMaxMinor));

        var disable = (minPriceMinor === maxPriceMinor);
        priceMinInput.disabled = disable;
        priceMaxInput.disabled = disable;
        priceMinRange.disabled = disable;
        priceMaxRange.disabled = disable;

        updatePriceRangeFill();
        updatePriceRangeAria();
      }

      function initPriceEvents() {
        if (!priceMinInput || !priceMaxInput || !priceMinRange || !priceMaxRange) return;

        function syncAndRequest(minMinor, maxMinor, options) {
          var opts = options || {};
          if (opts.touchMin) priceMinTouched = true;
          if (opts.touchMax) priceMaxTouched = true;

          var clamped = clampPriceMinor(minMinor, maxMinor);
          filters.priceMinMinor = clamped.min;
          filters.priceMaxMinor = clamped.max;

          // Sync UI
          priceMinInput.value = formatMajorNumber(minorToMajor(clamped.min));
          priceMaxInput.value = formatMajorNumber(minorToMajor(clamped.max));
          priceMinRange.value = formatMajorNumber(minorToMajor(clamped.min));
          priceMaxRange.value = formatMajorNumber(minorToMajor(clamped.max));

          updatePriceRangeFill();
          updatePriceRangeAria();
          currentPage = 1;
          slClearRestoredPageIntent();

          if (opts.persist) slPersistState({ url: "debounce", storage: true });
          if (opts.flush) flushRangeApply(true);
          else scheduleRangeApply();
        }

        var inputDebounce = null;
        function onPriceInputsTyped(event) {
          var touchedMin = event && event.currentTarget === priceMinInput;
          var touchedMax = event && event.currentTarget === priceMaxInput;
          if (touchedMin) priceMinTouched = true;
          if (touchedMax) priceMaxTouched = true;
          window.clearTimeout(inputDebounce);
          inputDebounce = window.setTimeout(function() {
            syncAndRequest(
              majorToMinor(priceMinInput.value),
              majorToMinor(priceMaxInput.value),
              { persist: true, flush: true, touchMin: touchedMin, touchMax: touchedMax }
            );
          }, 150);
        }

        priceMinInput.addEventListener("input", onPriceInputsTyped);
        priceMaxInput.addEventListener("input", onPriceInputsTyped);
        priceMinInput.addEventListener("change", onPriceInputsTyped);
        priceMaxInput.addEventListener("change", onPriceInputsTyped);

        [priceMinRange, priceMaxRange].forEach(function(rangeEl) {
          if (!rangeEl) return;
          rangeEl.addEventListener("focus", function() { setActivePriceRange(rangeEl); });
          if (window.PointerEvent) {
            rangeEl.addEventListener("pointerdown", function() {
              setActivePriceRange(rangeEl);
              markRangePointerActive();
            }, { passive: true });
            rangeEl.addEventListener("lostpointercapture", finishRangeViewportGuard);
          } else {
            rangeEl.addEventListener("mousedown", markRangePointerActive, { passive: true });
            rangeEl.addEventListener("touchstart", markRangePointerActive, { passive: true });
          }
        });

        priceMinRange.addEventListener("input", function() {
          beginRangeViewportGuard();
          queueResultsTopReset();

          var minMinor = majorToMinor(priceMinRange.value);
          var maxMinor = majorToMinor(priceMaxRange.value);
          if (minMinor > maxMinor) minMinor = maxMinor;
          syncAndRequest(minMinor, maxMinor, { touchMin: true });
          scheduleRangeViewportRecovery(140);
        });

        priceMaxRange.addEventListener("input", function() {
          beginRangeViewportGuard();
          queueResultsTopReset();

          var minMinor = majorToMinor(priceMinRange.value);
          var maxMinor = majorToMinor(priceMaxRange.value);
          if (maxMinor < minMinor) maxMinor = minMinor;
          syncAndRequest(minMinor, maxMinor, { touchMax: true });
          scheduleRangeViewportRecovery(140);
        });

        function commitPriceRange() {
          syncAndRequest(filters.priceMinMinor, filters.priceMaxMinor, { persist: true, flush: true });
          finishRangeViewportGuard();
        }

        priceMinRange.addEventListener("change", commitPriceRange);
        priceMaxRange.addEventListener("change", commitPriceRange);
        priceMinRange.addEventListener("blur", finishRangeViewportGuard);
        priceMaxRange.addEventListener("blur", finishRangeViewportGuard);

        if (priceRangeWrap) {
          priceRangeWrap.addEventListener("click", function(event) {
            if (event.target === priceMinRange || event.target === priceMaxRange) return;
            if (typeof event.button === "number" && event.button !== 0) return;

            var rect = priceRangeWrap.getBoundingClientRect();
            if (!rect.width) return;

            var pct = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
            var clickedMinor = Math.round(minPriceMinor + ((maxPriceMinor - minPriceMinor) * pct));
            var minDistance = Math.abs(clickedMinor - filters.priceMinMinor);
            var maxDistance = Math.abs(clickedMinor - filters.priceMaxMinor);
            var useMin = minDistance < maxDistance || (minDistance === maxDistance && clickedMinor <= filters.priceMinMinor);

            if (useMin) {
              setActivePriceRange(priceMinRange);
              syncAndRequest(Math.min(clickedMinor, filters.priceMaxMinor), filters.priceMaxMinor, { persist: true, flush: true, touchMin: true });
              priceMinRange.focus({ preventScroll: true });
            } else {
              setActivePriceRange(priceMaxRange);
              syncAndRequest(filters.priceMinMinor, Math.max(clickedMinor, filters.priceMinMinor), { persist: true, flush: true, touchMax: true });
              priceMaxRange.focus({ preventScroll: true });
            }
          });
        }
      }

      // ---- Capacity helpers ----
      function formatCapacityValue(value) {
        if (!isFinite(value)) return "";
        return Number(value.toFixed(3)).toString();
      }

      function capacityIndexForValue(value) {
        if (!capacityValues.length) return 0;
        var requested = parseFloat(value);
        if (!isFinite(requested) || requested <= 0) return 0;
        for (var i = 0; i < capacityValues.length; i++) {
          if (capacityValues[i] >= requested) return i + 1;
        }
        return capacityValues.length;
      }

      function capacityValueForIndex(index) {
        if (!capacityValues.length) return 0;
        var safeIndex = Math.max(0, Math.min(capacityValues.length, Math.round(parseFloat(index) || 0)));
        if (safeIndex === 0) return 0;
        return capacityValues[safeIndex - 1];
      }

      function updateCapacityRangeAria() {
        if (!capacityRange) return;
        var text = filters.capacityMin > 0
          ? formatCapacityValue(filters.capacityMin) + " pounds minimum"
          : "Any capacity";
        capacityRange.setAttribute("aria-valuetext", text);
      }

      function updateCapacityRangeFill() {
        if (!capacityRangeFill || !capacityRange) return;

        var index = parseFloat(capacityRange.value) || 0;
        var range = Math.max(1, capacityValues.length);
        var pct = (index / range) * 100;
        pct = Math.max(0, Math.min(100, pct));

        capacityRangeFill.style.left = pct + "%";
        capacityRangeFill.style.right = "0%";
      }

      function clampCapacityValue(value) {
        if (!isFinite(parseFloat(value)) || parseFloat(value) <= 0) return 0;
        return capacityValueForIndex(capacityIndexForValue(value));
      }

      function updateCapacityInputsFromState() {
        if (!capacityInput || !capacityRange) return;

        capacityInput.min = minCapacity;
        capacityInput.max = maxCapacity;
        capacityInput.step = "any";
        capacityInput.placeholder = "Any";

        capacityRange.min = 0;
        capacityRange.max = capacityValues.length;
        capacityRange.step = 1;

        if (hasLoadedAllProducts) filters.capacityMin = clampCapacityValue(filters.capacityMin);
        capacityInput.value = filters.capacityMin > 0 ? formatCapacityValue(filters.capacityMin) : "";
        capacityRange.value = capacityIndexForValue(filters.capacityMin);

        var disable = !hasCapacityFacet;
        capacityInput.disabled = disable;
        capacityRange.disabled = disable;

        updateCapacityRangeFill();
        updateCapacityRangeAria();
      }

      function initCapacityEvents() {
        if (!capacityInput || !capacityRange) return;

        if (window.PointerEvent) {
          capacityRange.addEventListener("pointerdown", markRangePointerActive, { passive: true });
          capacityRange.addEventListener("lostpointercapture", finishRangeViewportGuard);
        } else {
          capacityRange.addEventListener("mousedown", markRangePointerActive, { passive: true });
          capacityRange.addEventListener("touchstart", markRangePointerActive, { passive: true });
        }

        capacityInput.addEventListener("change", function() {
          capacityTouched = true;
          queueResultsTopReset();

          var value = clampCapacityValue(parseFloat(capacityInput.value));
          filters.capacityMin = value;
          capacityInput.value = value > 0 ? formatCapacityValue(value) : "";
          capacityRange.value = capacityIndexForValue(value);
          updateCapacityRangeFill();
          updateCapacityRangeAria();
          currentPage = 1;
          slClearRestoredPageIntent();
          slPersistState({ url: "debounce", storage: true });
          flushRangeApply(true);
        });

        capacityRange.addEventListener("input", function() {
          beginRangeViewportGuard();
          queueResultsTopReset();

          capacityTouched = true;
          var value = capacityValueForIndex(capacityRange.value);
          filters.capacityMin = value;
          capacityInput.value = value > 0 ? formatCapacityValue(value) : "";
          updateCapacityRangeFill();
          updateCapacityRangeAria();
          currentPage = 1;
          slClearRestoredPageIntent();
          scheduleRangeApply();
          scheduleRangeViewportRecovery(140);
        });

        capacityRange.addEventListener("change", function() {
          slPersistState({ url: "debounce", storage: true });
          flushRangeApply(true);
          finishRangeViewportGuard();
        });
        capacityRange.addEventListener("blur", finishRangeViewportGuard);
      }

      // ---- Facets (Material) ----
      function buildFacetOptions() {
        var materialsSet = {};

        cardRecords.forEach(function(record) {
          var material = record.material;
          if (material) materialsSet[material] = true;
        });

        // Keep restored/active material choices visible even before the product
        // page containing that material has finished loading.
        (filters.materials || []).forEach(function(mat) {
          var selectedMaterial = (mat || "").trim();
          if (selectedMaterial) materialsSet[selectedMaterial] = true;
        });

        var materials = Object.keys(materialsSet).sort(function(a, b) {
          return a.localeCompare(b);
        });

        var nextMaterialSignature = materials.join("\u001f");
        if (materialContainer) {
          var existingInputs = Array.prototype.slice.call(materialContainer.querySelectorAll("input[data-ccf-filter='material']"));
          var existingByValue = Object.create(null);
          existingInputs.forEach(function(input) {
            existingByValue[input.value] = input;
          });

          if (nextMaterialSignature !== materialOptionsSignature) {
            materials.forEach(function(mat) {
              if (existingByValue[mat]) return;

              var label = document.createElement("label");
              label.className = "ccf-chip";

              var input = document.createElement("input");
              input.type = "checkbox";
              input.value = mat;
              input.setAttribute("data-ccf-filter", "material");

              var text = document.createElement("span");
              text.textContent = mat;

              label.appendChild(input);
              label.appendChild(text);
              materialContainer.appendChild(label);
              existingByValue[mat] = input;
            });

            existingInputs.forEach(function(input) {
              if (materialsSet[input.value]) return;
              var label = input.closest("label");
              if (label) label.remove();
            });

            materialOptionsSignature = nextMaterialSignature;
          }

          Array.prototype.forEach.call(materialContainer.querySelectorAll("input[data-ccf-filter='material']"), function(input) {
            input.checked = filters.materials.indexOf(input.value) !== -1;
          });
        }

        var materialGroup = root.querySelector("[data-ccf-group='material']");
        if (materialGroup) {
          // If user has a material filter active, do not hide the group even if we haven't loaded all products yet.
          if (hasLoadedAllProducts && !materials.length && !filters.materials.length) materialGroup.classList.add("ccf-filter-group--hidden");
          else materialGroup.classList.remove("ccf-filter-group--hidden");
        }

        var capacityGroup = root.querySelector("[data-ccf-group='capacity']");
        if (capacityGroup) {
          if (hasLoadedAllProducts && !hasCapacityFacet) capacityGroup.classList.add("ccf-filter-group--hidden");
          else capacityGroup.classList.remove("ccf-filter-group--hidden");
        }
      }

      function recomputeFacetsAndRangesAfterLoad() {
        // Price bounds
        var minPrices = [];
        var maxPrices = [];

        // Capacity bounds
        var caps = [];

        cardRecords.forEach(function(record) {
          var pmin = record.priceMinMinor;
          var pmax = record.priceMaxMinor;

          if (!isNaN(pmin) && pmin >= 0) minPrices.push(pmin);
          if (!isNaN(pmax) && pmax >= 0) maxPrices.push(pmax);

          var cap = record.capacity;
          if (!isNaN(cap) && cap > 0) caps.push(cap);
        });

        if (!minPrices.length) minPrices = [0];
        if (!maxPrices.length) maxPrices = [0];

        minPriceMinor = Math.min.apply(Math, minPrices);
        maxPriceMinor = Math.max.apply(Math, maxPrices);

        capacityValues = uniqueSortedNumbers(caps);
        hasCapacityFacet = capacityValues.length > 0;
        minCapacity = hasCapacityFacet ? capacityValues[0] : 0;
        maxCapacity = hasCapacityFacet ? capacityValues[capacityValues.length - 1] : 0;

        // Expand defaults only if user hasn't touched those controls. If values were
        // restored from URL/storage, avoid clamping them to partial collection bounds
        // until every Shopify page has been merged.
        if (!priceMinTouched) filters.priceMinMinor = minPriceMinor;
        if (!priceMaxTouched) filters.priceMaxMinor = maxPriceMinor;
        if (hasLoadedAllProducts) {
          var clamped = clampPriceMinor(filters.priceMinMinor, filters.priceMaxMinor);
          filters.priceMinMinor = clamped.min;
          filters.priceMaxMinor = clamped.max;
        } else {
          var restoredPrice = slNormalizeRestoredMinorRange(
            filters.priceMinMinor,
            filters.priceMaxMinor,
            priceMinTouched,
            priceMaxTouched
          );
          filters.priceMinMinor = restoredPrice.min;
          filters.priceMaxMinor = restoredPrice.max;
        }

        if (!capacityTouched) {
          filters.capacityMin = 0;
        } else if (hasLoadedAllProducts) {
          filters.capacityMin = clampCapacityValue(filters.capacityMin);
        } else {
          filters.capacityMin = Math.max(0, parseFloat(filters.capacityMin) || 0);
        }

        buildFacetOptions();
        updatePriceInputsFromState();
        updateCapacityInputsFromState();
      }

      // ---- Filtering & Sorting ----
      function getMatchingCards(orderedCards) {
        return (orderedCards || getOrderedCards()).filter(function(card) {
          var record = getCardRecord(card);

          // Availability
          if (filters.hideOutOfStock && !record.available) return false;

          // Price filter (range intersection)
          if (record.priceMaxMinor < filters.priceMinMinor) return false;
          if (record.priceMinMinor > filters.priceMaxMinor) return false;

          // Capacity filter applies only if facet exists and user moved above min
          if (hasCapacityFacet && filters.capacityMin > 0) {
            if (isNaN(record.capacity) || record.capacity < filters.capacityMin) return false;
          }

          // Material filter
          if (filters.materials.length && filters.materials.indexOf(record.material) === -1) return false;

          // On sale (any variant discounted)
          if (filters.onSaleOnly && !record.onSale) return false;

          // Custom only
          if (filters.customOnly && record.custom !== "custom") return false;

          return true;
        });
      }

      function getTitle(card) {
        return getCardRecord(card).title;
      }

      function getPriceMinMinor(card) {
        return getCardRecord(card).priceMinMinor;
      }

      function getIndex(card) {
        return getCardRecord(card).index;
      }

      function sortCards(cardsArr) {
        var arr = cardsArr.slice();

        if (sortState === "title-asc") {
          arr.sort(function(a, b) {
            var compared = titleCollator ? titleCollator.compare(getTitle(a), getTitle(b)) : getTitle(a).localeCompare(getTitle(b));
            return compared || (getIndex(a) - getIndex(b));
          });
        } else if (sortState === "title-desc") {
          arr.sort(function(a, b) {
            var compared = titleCollator ? titleCollator.compare(getTitle(b), getTitle(a)) : getTitle(b).localeCompare(getTitle(a));
            return compared || (getIndex(a) - getIndex(b));
          });
        } else if (sortState === "price-asc") {
          arr.sort(function(a, b) { return (getPriceMinMinor(a) - getPriceMinMinor(b)) || (getIndex(a) - getIndex(b)); });
        } else if (sortState === "price-desc") {
          arr.sort(function(a, b) { return (getPriceMinMinor(b) - getPriceMinMinor(a)) || (getIndex(a) - getIndex(b)); });
        } else {
          arr.sort(function(a, b) { return getIndex(a) - getIndex(b); });
        }

        return arr;
      }

      function getOrderedCards() {
        if (orderedCardsCacheVersion === cardsVersion && orderedCardsCacheSort === sortState) {
          return orderedCardsCache;
        }

        orderedCardsCache = sortCards(cards);
        orderedCardsCacheVersion = cardsVersion;
        orderedCardsCacheSort = sortState;
        return orderedCardsCache;
      }

      function syncDomOrder(orderedCards) {
        if (!grid) return;
        if (domOrderVersion === cardsVersion && domOrderSort === sortState) return;
        var frag = document.createDocumentFragment();
        orderedCards.forEach(function(card) {
          frag.appendChild(card);
        });
        grid.appendChild(frag);
        domOrderVersion = cardsVersion;
        domOrderSort = sortState;
      }

      // ---- Pagination + counts ----
      function prefersReducedCollectionMotion() {
        return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
      }

      function resetGridPageAnimation() {
        if (gridPageAnimation) {
          try { gridPageAnimation.cancel(); } catch (e) {}
          gridPageAnimation = null;
        }

        if (grid) grid.style.minHeight = gridPageAnimationOriginalMinHeight;
        gridPageAnimationOriginalMinHeight = "";
      }

      function animateGridPageChange(updateView) {
        if (typeof updateView !== "function") return;
        if (!grid) {
          updateView();
          return;
        }

        resetGridPageAnimation();
        gridPageAnimationOriginalMinHeight = grid.style.minHeight || "";

        var currentHeight = Math.ceil(grid.getBoundingClientRect().height || 0);
        if (currentHeight > 0) grid.style.minHeight = currentHeight + "px";

        updateView();

        if (prefersReducedCollectionMotion() || typeof grid.animate !== "function") {
          grid.style.minHeight = gridPageAnimationOriginalMinHeight;
          gridPageAnimationOriginalMinHeight = "";
          return;
        }

        var animation = grid.animate([
          { opacity: 0.5, transform: "translateY(4px)" },
          { opacity: 1, transform: "translateY(0)" }
        ], {
          duration: 180,
          easing: "ease-out"
        });

        gridPageAnimation = animation;

        var finish = function() {
          if (gridPageAnimation !== animation) return;
          gridPageAnimation = null;
          grid.style.minHeight = gridPageAnimationOriginalMinHeight;
          gridPageAnimationOriginalMinHeight = "";
        };

        animation.finished.then(finish, finish);
      }

      function updateProductCountText(actualMatching, totalForText) {
        if (!productCountText) return;

        var total = totalForText;
        if (typeof total !== "number") total = parseInt(total, 10);
        if (isNaN(total) || total < 0) total = actualMatching;

        var start = 0;
        var end = 0;

        if (actualMatching > 0) {
          start = (currentPage - 1) * ITEMS_PER_PAGE + 1;
          end = Math.min(actualMatching, currentPage * ITEMS_PER_PAGE);
          if (end < start) start = end;
        }

        var text = "";
        if (total === 0 || actualMatching === 0) {
          text = "Showing 0 products";
        } else if (total === 1) {
          text = "Showing 1 product";
        } else {
          text = "Showing " + start + "–" + end + " of " + total + " products";
        }

        productCountText.textContent = text;
      }

      function showServerPageState() {
        if (paginationEl) paginationEl.style.display = "none";
        var visibleCards = 0;
        cards.forEach(function(card) {
          var isAvailable = card.getAttribute("data-available") === "1";
          var shouldShow = !filters.hideOutOfStock || isAvailable;
          setCardPageVisibility(card, shouldShow);
          if (shouldShow) visibleCards += 1;
        });
        if (noResultsEl) noResultsEl.hidden = visibleCards > 0;
        if (!productCountText) return;

        var total = Math.max(0, slSafeParseInt(CCF_TOTAL_ITEMS, cards.length));
        var start = cards.length ? ((Math.max(1, CCF_CURRENT_SERVER_PAGE) - 1) * CCF_PAGE_SIZE + 1) : 0;
        var end = cards.length ? Math.min(total, start + cards.length - 1) : 0;

        if (!visibleCards) productCountText.textContent = "Showing 0 available products on this page";
        else if (filters.hideOutOfStock && total === 1) productCountText.textContent = "Showing 1 available product";
        else if (filters.hideOutOfStock && visibleCards === 1) productCountText.textContent = "Showing 1 available product on this page · " + total + " products total";
        else if (filters.hideOutOfStock) productCountText.textContent = "Showing " + visibleCards + " available products on this page · " + total + " products total";
        else if (total === 1) productCountText.textContent = "Showing 1 product";
        else productCountText.textContent = "Showing " + start + "–" + end + " of " + total + " products";
      }

      function endServerPageNavigation() {
        if (!root.classList.contains("ccf-section--navigating") && !serverNavigationResetTimer) return;

        window.clearTimeout(serverNavigationResetTimer);
        serverNavigationResetTimer = null;
        root.classList.remove("ccf-section--navigating");
        root.removeAttribute("aria-busy");

        if (loadingTextEl && loadingTextEl.textContent === "Loading page…") {
          loadingTextEl.hidden = true;
          loadingTextEl.textContent = "";
        }
      }

      function beginServerPageNavigation(event) {
        if (!event || event.defaultPrevented || isLoadingAllProducts) return;
        if (typeof event.button === "number" && event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var target = event.target;
        var link = target && target.closest ? target.closest("a[href]") : null;
        if (!link || link.hasAttribute("download")) return;
        if (link.target && link.target.toLowerCase() !== "_self") return;

        try {
          if (new URL(link.href, window.location.href).origin !== window.location.origin) return;
        } catch (e) {
          return;
        }

        root.classList.add("ccf-section--navigating");
        root.setAttribute("aria-busy", "true");

        if (loadingTextEl) {
          loadingTextEl.hidden = false;
          loadingTextEl.textContent = "Loading page…";
        }

        window.clearTimeout(serverNavigationResetTimer);
        serverNavigationResetTimer = window.setTimeout(endServerPageNavigation, 4000);
      }

      function addPageButton(page) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ccf-pagination__button";
        btn.textContent = String(page);
        btn.setAttribute("data-ccf-page", String(page));
        if (page === currentPage) {
          btn.className += " ccf-pagination__button--active";
          btn.setAttribute("aria-current", "page");
        }
        return btn;
      }

      function updatePaginationUI(totalMatching, totalPages) {
        if (!paginationEl) return;

        var nextSignature = [totalMatching, totalPages, currentPage].join(":");
        if (nextSignature === paginationSignature) return;
        paginationSignature = nextSignature;

        paginationEl.innerHTML = "";

        if (totalPages <= 1 || totalMatching === 0) {
          paginationEl.style.display = "none";
          return;
        }

        paginationEl.style.display = "flex";

        var prevBtn = document.createElement("button");
        prevBtn.type = "button";
        prevBtn.className = "ccf-pagination__button";
        prevBtn.setAttribute("data-ccf-page", "prev");
        prevBtn.setAttribute("aria-label", "Previous page");
        prevBtn.textContent = "Previous";
        if (currentPage === 1) prevBtn.disabled = true;
        paginationEl.appendChild(prevBtn);

        var pagesToShow = [];
        if (totalPages <= 5) {
          for (var i = 1; i <= totalPages; i++) pagesToShow.push(i);
        } else {
          if (currentPage <= 4) {
            pagesToShow = [1, 2, 3, 4, "...", totalPages];
          } else if (currentPage >= totalPages - 3) {
            pagesToShow = [1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
          } else {
            pagesToShow = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
          }
        }

        pagesToShow.forEach(function(item) {
          if (item === "...") {
            var span = document.createElement("span");
            span.className = "ccf-pagination__ellipsis";
            span.textContent = "…";
            paginationEl.appendChild(span);
          } else {
            paginationEl.appendChild(addPageButton(item));
          }
        });

        var nextBtn = document.createElement("button");
        nextBtn.type = "button";
        nextBtn.className = "ccf-pagination__button";
        nextBtn.setAttribute("data-ccf-page", "next");
        nextBtn.setAttribute("aria-label", "Next page");
        nextBtn.textContent = "Next";
        if (currentPage === totalPages) nextBtn.disabled = true;
        paginationEl.appendChild(nextBtn);
      }

      function setCardPageVisibility(card, shouldShow) {
        if (!card) return;

        var isHidden = card.classList.contains("ccf-grid__item--page-hidden");
        if ((shouldShow && !isHidden) || (!shouldShow && isHidden)) {
          if (shouldShow) visibleCardSet.add(card);
          else visibleCardSet.delete(card);
          return;
        }

        if (shouldShow) {
          card.classList.remove("ccf-grid__item--page-hidden");
          card.removeAttribute("aria-hidden");
          if ("inert" in card) card.inert = false;
          visibleCardSet.add(card);
        } else {
          card.classList.add("ccf-grid__item--page-hidden");
          card.setAttribute("aria-hidden", "true");
          if ("inert" in card) card.inert = true;
          visibleCardSet.delete(card);
        }
      }

      function applyPagination(matchingCards, totalForText) {
        var totalMatching = matchingCards.length;
        var totalPages = totalMatching === 0 ? 0 : Math.ceil(totalMatching / ITEMS_PER_PAGE);

        if (totalPages === 0) {
          Array.from(visibleCardSet).forEach(function(card) { setCardPageVisibility(card, false); });
          if (noResultsEl) noResultsEl.hidden = false;
          updatePaginationUI(0, 0);
          updateProductCountText(0, totalForText);
          currentPage = 1;
          return;
        }

        if (noResultsEl) noResultsEl.hidden = true;

        if (currentPage > totalPages) currentPage = totalPages;
        if (currentPage < 1) currentPage = 1;

        var startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
        var endIndex = startIndex + ITEMS_PER_PAGE;

        var nextVisibleCards = new Set(matchingCards.slice(startIndex, endIndex));
        Array.from(visibleCardSet).forEach(function(card) {
          if (!nextVisibleCards.has(card)) setCardPageVisibility(card, false);
        });
        nextVisibleCards.forEach(function(card) {
          setCardPageVisibility(card, true);
        });

        updatePaginationUI(totalMatching, totalPages);
        updateProductCountText(totalMatching, totalForText);

      }

      function applyFilters() {
        var orderedCards = getOrderedCards();
        var matchingCards = getMatchingCards(orderedCards);

        var totalForText = getTotalForText(matchingCards.length);

        if (root.classList.contains("ccf-section--filters-open")) {
          mobilePreviewDirty = true;
          updateClearAndToggleUI();
          updateApplyButton(totalForText);
          return;
        }

        syncDomOrder(orderedCards);
        applyPagination(matchingCards, totalForText);
        updateClearAndToggleUI();
        updateApplyButton(totalForText);
        restoreReturnPositionWhenReady();
        if (!rangeViewportGuardActive) notifyWishlistForVisibleView("collection-view-updated");

        if (!rangeViewportGuardActive) {
          flushResultsTopReset();
        }
      }

      function resetFilters() {
        priceMinTouched = false;
        priceMaxTouched = false;
        capacityTouched = false;
        queueResultsTopReset();

        filters.priceMinMinor = minPriceMinor;
        filters.priceMaxMinor = maxPriceMinor;
        filters.capacityMin = 0;
        filters.materials = [];
        filters.hideOutOfStock = true;
        filters.onSaleOnly = false;
        filters.customOnly = false;

        var inputs = root.querySelectorAll("input[data-ccf-filter]");
        Array.prototype.forEach.call(inputs, function(input) {
          if (input.type === "checkbox") input.checked = false;
        });

        updateHideOosControl();
        if (onSaleCheckbox) onSaleCheckbox.checked = false;
        if (customCheckbox) customCheckbox.checked = false;

        updatePriceInputsFromState();
        updateCapacityInputsFromState();
        currentPage = 1;
        slClearRestoredPageIntent();
        slPersistState({ url: "immediate", storage: true });
        requestApply();
      }

      // ---- Events ----
      function initFilterEvents() {
        root.addEventListener("change", function(event) {
          var target = event.target;
          if (!target) return;

          if (target.tagName === "INPUT" && target.hasAttribute("data-ccf-filter")) {
            var type = target.getAttribute("data-ccf-filter");

            if (type === "material") {
              var checkedMats = root.querySelectorAll("input[data-ccf-filter='material']:checked");
              filters.materials = Array.prototype.map.call(checkedMats, function(i) { return i.value; });
            } else if (type === "hide-oos") {
              filters.hideOutOfStock = !!target.checked;
              updateHideOosControl();
            } else if (type === "on-sale") {
              filters.onSaleOnly = !!target.checked;
            } else if (type === "custom-only") {
              filters.customOnly = !!target.checked;
            }

            currentPage = 1;
            slClearRestoredPageIntent();
            queueResultsTopReset();
            slPersistState({ url: "immediate", storage: true });
            requestApply();
          }
        });

        if (clearButton) {
          clearButton.addEventListener("click", function() {
            resetFilters();
          });
        }

        if (toggleFiltersButton) {
          toggleFiltersButton.addEventListener("click", function() {
            if (root.classList.contains("ccf-section--filters-open")) closeFilters();
            else openFilters();
          });
        }

        if (closeFiltersButton) {
          closeFiltersButton.addEventListener("click", function() {
            closeFilters();
          });
        }

        if (applyFiltersButton) {
          applyFiltersButton.addEventListener("click", function() {
            closeFilters();
          });
        }

        if (backdrop) {
          backdrop.addEventListener("click", function() {
            closeFilters();
          });
        }

        root.addEventListener("keydown", function(e) {
          if (e.key === "Escape" && root.classList.contains("ccf-section--filters-open")) {
            e.preventDefault();
            closeFilters();
          }
        });

        if (paginationEl) {
          paginationEl.addEventListener("click", function(event) {
            var target = event.target;
            if (!target || target.tagName !== "BUTTON") return;

            var page = target.getAttribute("data-ccf-page");
            if (!page) return;

            var matchingCards = getMatchingCards(getOrderedCards());
            var totalMatching = matchingCards.length;
            var totalPages = totalMatching === 0 ? 0 : Math.ceil(totalMatching / ITEMS_PER_PAGE);

            var oldPage = currentPage;

            if (page === "prev" && currentPage > 1) currentPage -= 1;
            else if (page === "next" && currentPage < totalPages) currentPage += 1;
            else if (page !== "prev" && page !== "next") {
              var num = parseInt(page, 10);
              if (!isNaN(num)) currentPage = num;
            }

            if (currentPage !== oldPage) {
              slClearRestoredPageIntent();
              // Persist immediately so browser-back returns to this page
              slPersistState({ url: "immediate", storage: true });
              animateGridPageChange(function() {
                applyPagination(matchingCards, getTotalForText(totalMatching));
                notifyWishlistForVisibleView("collection-page-changed");
              });
              scrollToSectionTop();
            }
          });
        }

        if (serverPaginationEl) {
          serverPaginationEl.addEventListener("click", beginServerPageNavigation, true);
        }
      }

      function initSortAndPageSizeEvents() {
        if (sortSelect) {
          sortSelect.addEventListener("change", function() {
            sortState = slNormalizeSort(sortSelect.value || "default");
            currentPage = 1;
            slClearRestoredPageIntent();
            queueResultsTopReset();
            slPersistState({ url: "immediate", storage: true });
            requestApply();
          });
        }

        if (pageSizeSelect) {
          pageSizeSelect.addEventListener("change", function() {
            var value = slNormalizePerPage(pageSizeSelect.value);
            if (!value || value < 1) return;

            // Preserve the shopper's position when changing "Show"
            var oldSize = ITEMS_PER_PAGE;
            var oldFirstIndex = (currentPage - 1) * oldSize;

            ITEMS_PER_PAGE = value;

            var newPage = Math.floor(oldFirstIndex / ITEMS_PER_PAGE) + 1;
            if (!newPage || newPage < 1) newPage = 1;
            currentPage = newPage;
            slClearRestoredPageIntent();

            pageSizeSelect.value = String(ITEMS_PER_PAGE);

            slPersistState({ url: "immediate", storage: true });
            requestApply();
          });
        }
      }

      function initAccordion() {
        var groups = Array.prototype.slice.call(root.querySelectorAll("[data-ccf-accordion]"));
        if (!groups.length) return;

        function setOpen(group, open) {
          group.classList.toggle("ccf-filter-group--open", !!open);
          var btn = group.querySelector("[data-ccf-accordion-toggle]");
          var panel = group.querySelector("[data-ccf-accordion-panel]");
          if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
          if (panel) panel.hidden = !open;
        }

        groups.forEach(function(group) {
          var isDefault = group.hasAttribute("data-ccf-accordion-default");
          setOpen(group, isDefault);
        });

        groups.forEach(function(group) {
          var btn = group.querySelector("[data-ccf-accordion-toggle]");
          if (!btn) return;

          btn.addEventListener("click", function() {
            var isOpen = group.classList.contains("ccf-filter-group--open");
            setOpen(group, !isOpen);
            if (isOpen || hasLoadedAllProducts || isLoadingAllProducts) return;
            loadAllProductsAcrossPages();
          });
        });
      }

      // ---- Load all native paginate pages after shopper interaction ----
      var catalogAbortController = window.AbortController ? new AbortController() : null;
      var wishlistRefreshTimer = null;
      var wishlistSyncRaf = null;
      var wishlistObserver = null;
      var lastWishlistViewKey = "";

      function syncWishlistButtons() {
        cards.forEach(function(card) {
          var slot = card.querySelector("[data-ccf-wishlist-slot]");
          if (!slot) return;

          var candidate = card.querySelector(".Vtl-WishlistButtonWrapper, .Vtl-WishlistButton");
          if (!candidate || slot.contains(candidate)) return;

          var wrapper = candidate.closest && candidate.closest(".Vtl-WishlistButtonWrapper");
          slot.appendChild(wrapper || candidate);
        });
      }

      function scheduleWishlistButtonSync() {
        if (wishlistSyncRaf) return;
        wishlistSyncRaf = window.requestAnimationFrame(function() {
          wishlistSyncRaf = null;
          syncWishlistButtons();
        });
      }

      function requestWishlistRefresh(reason) {
        window.clearTimeout(wishlistRefreshTimer);
        wishlistRefreshTimer = window.setTimeout(function() {
          wishlistRefreshTimer = null;
          var detail = { reason: reason || "collection-updated", root: root };
          [
            "wishlist-by-square:refresh",
            "square-wishlist:refresh",
            "square:wishlist:refresh",
            "SquareWishlist:refresh",
            "vitals:wishlist:refresh",
            "shopify:product-cards:updated",
            "product-card:loaded"
          ].forEach(function(eventName) {
            try { document.dispatchEvent(new CustomEvent(eventName, { detail: detail })); } catch (e) {}
            try { window.dispatchEvent(new CustomEvent(eventName, { detail: detail })); } catch (e) {}
          });

          [window.WishlistBySquare, window.SquareWishlist, window.VitalsWishlist].forEach(function(api) {
            if (!api) return;
            var method = typeof api.refresh === "function" ? "refresh" : (typeof api.render === "function" ? "render" : "");
            if (!method) return;
            try { api[method](root); } catch (e) {
              try { api[method](); } catch (ignored) {}
            }
          });
          scheduleWishlistButtonSync();
        }, 40);
      }

      function notifyWishlistForVisibleView(reason) {
        var key = Array.from(visibleCardSet).map(function(card) {
          return getCardRecord(card).productId;
        }).join("|");
        if (key === lastWishlistViewKey) return;
        lastWishlistViewKey = key;
        requestWishlistRefresh(reason);
      }

      function setLoadingState(isLoading, loadedCount, totalCount) {
        if (isLoading) root.setAttribute("aria-busy", "true");
        else root.removeAttribute("aria-busy");

        if (!loadingTextEl) return;
        if (!isLoading) {
          loadingTextEl.hidden = true;
          loadingTextEl.textContent = "";
          return;
        }

        loadingTextEl.hidden = false;

        var text = "Loading products…";
        if (totalCount && loadedCount) text = "Loading products… (" + loadedCount + " of " + totalCount + ")";
        else if (loadedCount) text = "Loading products… (" + loadedCount + ")";

        loadingTextEl.textContent = text;
      }

      function fetchText(url) {
        var requestController = window.AbortController ? new AbortController() : null;
        var options = { credentials: "same-origin" };
        var timeoutId = null;
        var abortFromCatalog = null;

        if (requestController) {
          options.signal = requestController.signal;
          timeoutId = window.setTimeout(function() { requestController.abort(); }, 15000);
          if (catalogAbortController) {
            abortFromCatalog = function() { requestController.abort(); };
            if (catalogAbortController.signal.aborted) abortFromCatalog();
            else catalogAbortController.signal.addEventListener("abort", abortFromCatalog, { once: true });
          }
        }

        var request = fetch(url, options)
          .then(function(res) {
            if (!res.ok) throw new Error("HTTP " + res.status);
            return res.text();
          });

        if (!requestController) {
          request = Promise.race([
            request,
            new Promise(function(resolve, reject) {
              timeoutId = window.setTimeout(function() { reject(new Error("Request timed out")); }, 15000);
            })
          ]);
        }

        return request.finally(function() {
          window.clearTimeout(timeoutId);
          if (catalogAbortController && abortFromCatalog) {
            catalogAbortController.signal.removeEventListener("abort", abortFromCatalog);
          }
        });
      }

      function stripClientStateParams(searchParams) {
        if (!searchParams) return;

        Object.keys(SL_PARAMS).forEach(function(key) {
          searchParams.delete(SL_PARAMS[key]);
        });
      }

      function buildPageFetchUrl(pageNum, sectionOnly) {
        var url = new URL(window.location.href);

        stripClientStateParams(url.searchParams);
        url.searchParams.set("page", String(pageNum));
        url.searchParams.delete("sections");

        if (sectionOnly && CCF_SECTION_ID) {
          url.searchParams.set("section_id", CCF_SECTION_ID);
        } else {
          url.searchParams.delete("section_id");
        }

        return url.toString();
      }

      function parseFetchedPageCards(html) {
        var inertHtml = String(html || "")
          .replace(/\bloading\s*=\s*(["'])eager\1/gi, "loading=$1lazy$1")
          .replace(/\bfetchpriority\s*=\s*(["'])high\1/gi, "fetchpriority=$1low$1");
        var doc = new DOMParser().parseFromString(inertHtml, "text/html");
        var remoteRoot = doc.getElementById(root.id);
        if (!remoteRoot) return { rootFound: false, cards: [] };

        var remoteCards = Array.prototype.slice.call(remoteRoot.querySelectorAll("[data-ccf-product]"));
        var newCards = [];

        remoteCards.forEach(function(node) {
          var pid = node.getAttribute("data-product-id") || "";
          if (pid && loadedProductIds[pid]) return;
          if (pid) loadedProductIds[pid] = true;

          var importedCard = document.importNode(node, true);
          Array.prototype.forEach.call(importedCard.querySelectorAll("img"), function(image) {
            image.setAttribute("loading", "lazy");
            image.setAttribute("fetchpriority", "low");
          });
          newCards.push(importedCard);
        });

        return { rootFound: true, cards: newCards };
      }

      function validateFetchedPageCards(parsed, pageNum) {
        if (!parsed || !parsed.rootFound) {
          throw new Error("Collection section root missing for page " + pageNum);
        }
        if (!parsed.cards || !parsed.cards.length) {
          throw new Error("No product cards found for page " + pageNum);
        }

        return parsed.cards;
      }

      function fetchPageCards(pageNum) {
        var sectionUrl;
        var fullUrl;

        try {
          sectionUrl = buildPageFetchUrl(pageNum, true);
          fullUrl = buildPageFetchUrl(pageNum, false);
        } catch (e) {
          var fallbackQuery = "?page=" + encodeURIComponent(pageNum);
          if (CCF_SECTION_ID) fallbackQuery += "&section_id=" + encodeURIComponent(CCF_SECTION_ID);
          sectionUrl = window.location.pathname + fallbackQuery;
          fullUrl = window.location.pathname + "?page=" + encodeURIComponent(pageNum);
        }

        // Prefer Shopify's section-rendering response. It avoids fetching the header,
        // footer, app embeds, and unrelated scripts for every product batch.
        return fetchText(sectionUrl)
          .then(function(html) {
            var parsed = parseFetchedPageCards(html);
            if (parsed.rootFound && parsed.cards.length) return parsed.cards;

            if (sectionUrl === fullUrl) {
              return validateFetchedPageCards(parsed, pageNum);
            }

            // Fallback for unusual stores/proxies that do not return section HTML.
            return fetchText(fullUrl).then(function(fullHtml) {
              return validateFetchedPageCards(parseFetchedPageCards(fullHtml), pageNum);
            });
          }, function(err) {
            if (sectionUrl === fullUrl) throw err;

            return fetchText(fullUrl).then(function(fullHtml) {
              return validateFetchedPageCards(parseFetchedPageCards(fullHtml), pageNum);
            });
          });
      }

      function appendCards(newCards) {
        if (!newCards || !newCards.length || !grid) return;

        var frag = document.createDocumentFragment();
        newCards.forEach(function(card) {
          setCardPageVisibility(card, false);
          frag.appendChild(card);
        });
        grid.appendChild(frag);

        cards = cards.concat(newCards);
        indexCards(newCards, false);
      }

      var abortLoadAll = false;
      var isLoadingAllProducts = false;

      function getPrioritizedServerPageOrder() {
        var totalPages = slSafeParseInt(CCF_TOTAL_PAGES, 1);
        var serverPageSize = slSafeParseInt(CCF_PAGE_SIZE, DEFAULT_ITEMS_PER_PAGE);
        var clientPage = slGetPersistedPage();
        var order = [];
        var seen = {};

        function addPage(pageNum) {
          pageNum = slSafeParseInt(pageNum, 0);
          if (pageNum < 1 || pageNum > totalPages) return;
          if (seen[pageNum]) return;
          seen[pageNum] = true;
          order.push(pageNum);
        }

        if (serverPageSize > 0 && clientPage > 0) {
          var firstClientIndex = Math.max(0, (clientPage - 1) * ITEMS_PER_PAGE);
          var lastClientIndex = Math.max(firstClientIndex, firstClientIndex + ITEMS_PER_PAGE - 1);
          var firstServerPage = Math.floor(firstClientIndex / serverPageSize) + 1;
          var lastServerPage = Math.floor(lastClientIndex / serverPageSize) + 1;

          for (var priorityPage = firstServerPage; priorityPage <= lastServerPage; priorityPage++) {
            addPage(priorityPage);
          }
        }

        for (var p = 1; p <= totalPages; p++) {
          addPage(p);
        }

        return order;
      }

      async function loadAllProductsAcrossPages() {
        if (isLoadingAllProducts) return;
        isLoadingAllProducts = true;

        if (!CCF_TOTAL_PAGES || CCF_TOTAL_PAGES <= 1) {
          hasLoadedAllProducts = true;
          clientCatalogActive = true;
          isLoadingAllProducts = false;
          if (serverPaginationEl) serverPaginationEl.hidden = true;
          setLoadingState(false, cards.length, CCF_TOTAL_ITEMS || 0);
          applyFilters();
          return;
        }

        setLoadingState(true, cards.length, CCF_TOTAL_ITEMS || 0);

        var initialCards = cards.slice();
        var failedPages = [];
        var pageOrder = getPrioritizedServerPageOrder().filter(function(pageNum) {
          return pageNum !== CCF_CURRENT_SERVER_PAGE;
        });
        var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        var isMobileViewport = !!(window.matchMedia && window.matchMedia("(max-width: 749px)").matches);
        var effectiveType = connection && connection.effectiveType ? String(connection.effectiveType) : "";
        var batchSize = 4;
        if ((connection && connection.saveData) || effectiveType.indexOf("2g") !== -1) batchSize = 1;
        else if (isMobileViewport || effectiveType === "3g") batchSize = 2;

        for (var offset = 0; offset < pageOrder.length; offset += batchSize) {
          if (abortLoadAll) return;

          var batch = pageOrder.slice(offset, offset + batchSize);
          var results = await Promise.all(batch.map(function(pageNum) {
            return fetchPageCards(pageNum)
              .then(function(newCards) { return { page: pageNum, cards: newCards }; })
              .catch(function(error) { return { page: pageNum, cards: [], error: error }; });
          }));

          results.forEach(function(result) {
            if (result.error) {
              failedPages.push(result.page);
              console.warn("[CCF] Failed to load page " + result.page + ":", result.error);
              return;
            }
            appendCards(result.cards);
          });

          setLoadingState(true, cards.length, CCF_TOTAL_ITEMS || 0);
        }

        var expectedTotal = Math.max(0, slSafeParseInt(CCF_TOTAL_ITEMS, 0));
        if (failedPages.length === 0 && expectedTotal > 0 && cards.length !== expectedTotal) {
          failedPages.push("catalog-count");
          console.warn("[CCF] Loaded " + cards.length + " unique products; expected " + expectedTotal + ".");
        }

        hasLoadedAllProducts = failedPages.length === 0;
        isLoadingAllProducts = false;

        if (!hasLoadedAllProducts) {
          clientCatalogActive = false;
          if (serverPaginationEl) serverPaginationEl.hidden = false;
          cards.slice(initialCards.length).forEach(function(card) { card.remove(); });
          cards = initialCards;
          visibleCardSet.clear();
          indexCards(cards, true);
          materialOptionsSignature = "";
          loadedProductIds = {};
          cards.forEach(function(card) {
            var productId = card.getAttribute("data-product-id") || "";
            if (productId) loadedProductIds[productId] = true;
            setCardPageVisibility(card, true);
          });
          recomputeFacetsAndRangesAfterLoad();
          setLoadingState(false, cards.length, CCF_TOTAL_ITEMS || 0);
          if (loadingTextEl) {
            loadingTextEl.hidden = false;
            loadingTextEl.textContent = "Filters could not load the complete collection. Use the product page links below to continue browsing.";
          }
          showServerPageState();
          return;
        }

        clientCatalogActive = true;

        if (hasLoadedAllProducts && serverPaginationEl) {
          serverPaginationEl.hidden = true;
        }

        // Recompute once more with the final bounds, then restore the originally
        // requested client page after the full product set is available.
        recomputeFacetsAndRangesAfterLoad();

        if (hasLoadedAllProducts && restoredDesiredPage) {
          currentPage = restoredDesiredPage;
          restoredDesiredPage = null;
        }

        applyFilters();
        slPersistState({ url: "immediate", storage: true });
        setLoadingState(false, cards.length, CCF_TOTAL_ITEMS || 0);
        requestWishlistRefresh("collection-products-loaded");
      }

      // ---- Init ----
      // Restore state BEFORE we build facets and set UI values.
      var restoredInteractiveState = slRestoreStateFromUrlOrStorage();

      // Build facets & UI
      buildFacetOptions();
      updatePriceInputsFromState();
      updateCapacityInputsFromState();

      initPriceEvents();
      initCapacityEvents();
      initFilterEvents();
      initSortAndPageSizeEvents();
      initAccordion();
      updateStickyOffset();

      var resizeRaf = null;
      var resizeHandler = function() {
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function() {
          resizeRaf = null;
          updateStickyOffset();
        });
      };
      window.addEventListener("resize", resizeHandler);

      var rangeEndHandler = function() {
        if (rangeViewportGuardActive || rangePointerActive) finishRangeViewportGuard();
      };
      if (window.PointerEvent) {
        window.addEventListener("pointerup", rangeEndHandler, { passive: true });
        window.addEventListener("pointercancel", rangeEndHandler, { passive: true });
      } else {
        window.addEventListener("mouseup", rangeEndHandler, { passive: true });
        window.addEventListener("touchend", rangeEndHandler, { passive: true });
        window.addEventListener("touchcancel", rangeEndHandler, { passive: true });
      }
      window.addEventListener("blur", rangeEndHandler);

      var pageShowHandler = function(event) {
        endServerPageNavigation();
        if (!event || !event.persisted) return;
        if (pendingApplyOnPageShow) {
          pendingApplyOnPageShow = false;
          requestApply();
        }
        requestWishlistRefresh("collection-bfcache-restored");
      };
      window.addEventListener("pageshow", pageShowHandler);

      if (window.MutationObserver) {
        wishlistObserver = new window.MutationObserver(function(mutations) {
          var shouldSync = mutations.some(function(mutation) {
            return Array.prototype.some.call(mutation.addedNodes || [], function(node) {
              if (!node || node.nodeType !== 1) return false;
              if (node.matches && node.matches(".Vtl-WishlistButtonWrapper, .Vtl-WishlistButton")) return true;
              return !!(node.querySelector && node.querySelector(".Vtl-WishlistButtonWrapper, .Vtl-WishlistButton"));
            });
          });
          if (shouldSync) scheduleWishlistButtonSync();
        });
        wishlistObserver.observe(root, { childList: true, subtree: true });
      }
      requestWishlistRefresh("collection-initialized");

      // Cleanup on theme editor unload
      var sectionUnloadHandler = function(event) {
        if (!event || !event.detail) return;
        if (String(event.detail.sectionId) === String(CCF_SECTION_ID)) {
          abortLoadAll = true;
          if (catalogAbortController) catalogAbortController.abort();
          window.removeEventListener("pagehide", pageHideHandler);
          window.removeEventListener("resize", resizeHandler);
          window.removeEventListener("pointerup", rangeEndHandler);
          window.removeEventListener("pointercancel", rangeEndHandler);
          window.removeEventListener("mouseup", rangeEndHandler);
          window.removeEventListener("touchend", rangeEndHandler);
          window.removeEventListener("touchcancel", rangeEndHandler);
          window.removeEventListener("blur", rangeEndHandler);
          window.removeEventListener("pageshow", pageShowHandler);
          document.removeEventListener("shopify:section:unload", sectionUnloadHandler);
          window.clearTimeout(wishlistRefreshTimer);
          if (wishlistObserver) wishlistObserver.disconnect();
          if (wishlistSyncRaf) window.cancelAnimationFrame(wishlistSyncRaf);
          if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
          window.clearTimeout(serverNavigationResetTimer);
          serverNavigationResetTimer = null;
          resetGridPageAnimation();
          clearRangeViewportGuardTimer();
          rangeViewportGuardActive = false;
          rangePointerActive = false;
          unlockRootMinHeight();
          unlockBodyScroll();
          disableFocusTrap();
        }
      };
      document.addEventListener("shopify:section:unload", sectionUnloadHandler);

      if (restoredInteractiveState && restoredNeedsFullCatalog && !hasLoadedAllProducts) {
        loadAllProductsAcrossPages();
      } else if (restoredInteractiveState) {
        if (restoredNeedsFullCatalog) {
          clientCatalogActive = true;
          if (serverPaginationEl) serverPaginationEl.hidden = true;
          applyFilters();
        } else {
          showServerPageState();
          restoreReturnPositionWhenReady();
        }
      } else {
        showServerPageState();
      }

      // The full collection is fetched only after a shopper uses a filter, sort, or page-size control.
  }

  function initCollectionFilterScope(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (scope && scope.matches && scope.matches("[data-ccf-section]")) {
      initCollectionFilters(scope);
    }
    Array.prototype.forEach.call(context.querySelectorAll("[data-ccf-section]"), initCollectionFilters);
  }

  window.__ccfInitCollectionFilters = initCollectionFilterScope;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initCollectionFilterScope(document);
    }, { once: true });
  } else {
    initCollectionFilterScope(document);
  }

  document.addEventListener("shopify:section:load", function(event) {
    initCollectionFilterScope(event && event.target ? event.target : document);
  });
})();
